/**
 * Created by mauget on 2/22/16.
 */

// TODO Use util.enforceArraytype() instead of many two-legged ifs handling scalar vs array problem coming out of XML-to-Java.
// That tech debt reduces much D.R.Y violation, makes this huge module shorter and easier to read by hapless maintenance people.

import Immutable    from 'immutable';
import xjService    from 'xml/XJService';
import listService  from 'ListService';
import themeService from 'ThemeService';
import constants    from 'Constants';
import typeIndex    from 'typeIndex';
import factoryService       from 'FactoryService';
import pageInstanceFactory  from 'PageInstanceFactory';
import pageSyncService      from 'PageSyncService';
import pageCollection       from 'PageCollection';
import restService          from 'RestService';
import zLib                 from 'util/ZLib';
import userService              from 'UserService';
import util                 from 'util/Util';
import eventBus             from 'EventBus';
import _                    from 'lodash';
import BehaviorInstanceModel from 'BehaviorInstanceModel';
import assetCollection      from 'AssetCollection';
import objectBehaviorMap    from 'ObjectBehaviorMapService';
import sequenceService      from 'SequenceService';
import formulaService       from 'xml/FormulaService';
import ConnectionVO         from 'ConnectionVO';
import tableService         from 'TableService';
import LineModel from 'LineModel';
import undoService          from 'UndoService'
import DesignerModel 	from 'DesignerModel';
import viewManager      from 'ViewManagerService';
import GridColumnModel      from 'GridColumnModel';
import reportingMetaData from 'ReportingMetaDataModel';
import accountService from 'AccountService';
import Base64Decoder    from 'util/Base64Decoder';
import $ from "jquery";
import utilMobile from "../mobile/commons/MobileGeneralFunctions";

import TourService from 'TourService.js';


import defaultNotifySchema from "../controllers/DefaultNotifySchema";
import LeftPanelStateService from './LeftPanelStateService';
import RecoverDesignModal from '../views/dashboard/forms/modal/RecoverDesignModal';
import { Model }            from 'backbone';
import fontService from './FontService';
import mobileService from 'mobile/MobileService';

let self = undefined;

// Used to disable object model events until we complete loading.
const SILENT = constants.MODEL_SILENT;
const EMPTY = constants.STRING_EMPTY;

//===========================================================================================
// A singleton of this class encapsulates loading a PerfectForms object model.
//
// Object {Form: Object}
//  Form: Object
//  Dependencies: ""
//  Events: Object
//  Objects: Object  (this is recursive)
//  Pages: Object
//  Parameters: Object
//  Properties: Object
//  Scripts: Object
//  StartPages: Object
//  States: Object
//  Theme: Object
//  Workflow: Object
//      _docVersion: "0"
//      _guid: "ysVZCgAAZMEAAJRGAAAcWwvFb60="
//      _id: "126668"
//      _name: "POC Form (2) (2)"
//      _version: "0.1"
//
// -Lou Mauget, Feburary 22, 2016
//
//====================================================================================================================
// May 2, 2016:
//
// Storage of pages and groups:
//
// + listService holds form state
// + objList is an Immutable OrderedMap of objects
// + pageList is an Immutable OrderedMap of page headers - name, id, title
// + objList object having a "group" type and and ID noted in pageList is a page object
// + objList object having pageId matching a pageList ID belongs to and renders on that page
// + objList object having a groupId matchine another objects's ID is a child of that group
// + objList object of type "group", "radiobuttongroup" or "tickboxgroup" contains child objects (previous bullet)
//
// Inbound pageload:
//
// + A form load travels inbound as a Gzip'd, base64-encoded XML file via RestSerivce.
// + A resolved ES6 promise kicks off the action:
//   - zLib decodes and inflates the inbound XML form load
//   - xJService translates XML to JSON -- a JavaScript object, actually.
//   - FormLoadService loadForm assigns form load object items to the ListService.
//   - Loading driven by enumeratiing outer-elements of load in order (Pages, Objects, Theme, etc.)
//        (Alteratively could have loaded by plucking items at-will, in an ordering driven by a monad)
//   - PageSyncService orchestrates rendering a given page onto the layout.
//   - ThumbnamilListView clicks use PageSyncSdervice to choose and render a desired page.
//
//====================================================================================================================
class FormLoadService {
    constructor() {
        self = this;
        this.disp = Immutable.OrderedMap( {
            'Pages':            this._loadPages,
            'Workflow':         this._loadWorkflow,
            'Dependencies':     this._loadDependencies,
            'Theme':            this._loadTheme,
            'Parameters':       this._loadParameters,
            'Properties':       this._loadProperties,
            'Objects':          this._loadObjects,
            'Assets':           this._loadAssets,
            'StartPages':       this._loadStartPages,
            'DataSources':      this._loadDataSources,
            'Multilanguage':    this._loadMultilanguage,
            'AdvancedCSS':      this._loadAdvancedCSS,
            'ReportingMetaData':this._loadReportingMetaData
        });


        this.validDocAttributes = Immutable.Set( [ 'version', 'name', 'guid', 'id', 'docVersion' ] );
        this.reportingControls = Immutable.Set( [ 'datalist', 'barchart', 'piechart', 'linechart', 'gauge', 'value', 'filtersetter', 'filterselector', 'datagridrep', 'crosstab' ] );

        // A set of PF raw type names that are groups -- parents of other controls.
        this.groupSet =  Immutable.Set( [ 'group', 'radiobuttongroup', 'tickboxgroup' ]);

    }

    _determineOperatorValue(type) {
        let value = type;

        switch (type) {
            case "and":
                value = 'AND';
                break;
            case "or":
                value = 'OR';
                break;
            case "==":
                value = '=';
                break;
            case "ltgt":
                value = '<>';
                break;
            case "lt":
                value = '<';
                break;
            case "gt":
                value = '>';
                break;
            case "lt=":
                value = '<=';
                break;
            case "gt=":
                value = '>=';
                break;
        }

        return value;
    }

    //======================================================================
    // Given raw JSON presumably from the wire, populate the layout from
    // the JSON content.
    //======================================================================
    _displayForm( imJSON, opts )  {
        listService.loading = true;
        
        // "imJSON" contains the report and form's properties read from the XML, 
        // "formProperties" object contains all the properties needed to create 
        // the "currentForm" object through "FormFactory" changing the default values
        // with these properties' values which are read from "imJSON"
        let formProperties = { outsideColor: '#EEEEEE', width:500, height:400 };
        imJSON.forEach( (v, a) => {
              formProperties.outsideColor = '#' + v.Properties._outsideColor;
              formProperties.width = v.Properties._width;
              formProperties.height = v.Properties._height;
        });

        this.Pages = imJSON.get('Form').Pages.Page;

        // Tee up the designer layout editor with an empty model
        //listService.reset();
        const layoutView = listService.mainViews.get( constants.KIND_LAYOUT );
        layoutView.model.clear();
        layoutView.render(formProperties);

        // Load and inject properties into layout,
        this._loadForm( imJSON, opts );

    }


    //======================================================================
    // Given raw JSON presumably from the wire, populate the report page from
    // the JSON content.
    //======================================================================
    _displayReport( imJSON, opts )  {
        listService.loading = true;
        (function deafenMains() {
            listService.mainViews.map( view  => {
                view.undelegateEvents();
            });
        })();
        
        // "imJSON" contains the report and form's properties read from the XML, 
        // "formProperties" object contains all the properties needed to create 
        // the "currentForm" object through "FormFactory" changing the default values
        // with these properties' values which are read from "imJSON" 
        let formProperties = { outsideColor: '#EEEEEE', width:500, height:400 };
        imJSON.map( (v, a) => {
              formProperties.outsideColor ='#' + v.Properties._outsideColor;
              formProperties.width = v.Properties._width;
              formProperties.height = v.Properties._height;
        });

        // Lazily tee up the designer report editor with an empty model
        const reportView = listService.mainViews.get( constants.KIND_REPORT );
        reportView.model.clear();
        reportView.render(formProperties);

        // Load and inject properties into report UI,
        this._loadReport( imJSON, opts );
    }


    //======================================================================
    // Assumes an input FormXML attribute from a Form/Open payload.
    // Returns  <Form ... XML in cleartext.
    //======================================================================
    _decompressForm( rawForm ){
        const isCompressed = 'H4' === rawForm.slice(0, 2);
        const formXml = isCompressed ?
            zLib.decompressForm( rawForm ) :
            Base64Decoder.decodeToString( rawForm );
        console.log( formXml );
        return formXml;
    }
   
    //======================================================================
    // Call this method to load a remote form. If loading successful,
    // loads form into the UI. Either way, it returns a promise containing
    // completion notification values.
    //
    // PF-1956: Also captures current account detail settings before load.
    //======================================================================
    loadForm(formId, majorVersion, minorVersion, linkId, formName, formVersionId, lastUpdate, comesFromRecovery) {

        const openForm = (data) => {
            console.log(`Inbound compressed form: `, data.FormXML);
            let formXml = this._decompressForm(data.FormXML);
            formXml = util.minifyXMLString(formXml);
            const
                formDoc = formulaService.preprocess(formXml),
                formObj = xjService.xmlDocToJs(formDoc),
                form = { Form: formObj },
                formGUID = data.FormGUID;

            // KEEP THIS LOGGING for now. Useful to visualize what'scoming off the wire.
            console.log(`INBOUND JS: `, formObj);

            listService.currentForm = undefined;
            listService.orderedActiveBehaviors = [];
            
            const imJSON = Immutable.Map(formObj);
            let _majorVersion = majorVersion;
            let _minorVersion = minorVersion;

            if (util.isTrue(data.ComesFromRecovery) && data.Version){
                //Update majorVersion and minorVersion in case it changed after doing a recovery
                let _version = data.Version.split('.');
                if (_version.length === 2){
                    _majorVersion = _version[0];
                    _minorVersion = _version[1];
                }
            }

            this._displayForm(imJSON, {
                formId: formId,
                formGUID: formGUID,
                formName: formName,
                formLinkId: linkId,
                formVersionId: formVersionId,
                formMajorVersion: _majorVersion,
                formMinorVersion: _minorVersion
            });

            // Display success banner
            const p1 = `App "${data.Name} version ${data.Version}" `;

            //listService.setDirty();  // For time-being, any loaded document is dirty.  2016-05-06
            listService.currentForm.model.set('isDeployedVersion', data.IsDeployedVersion === 'True', { silent: true });
            listService.currentForm.model.set('isCurrentVersion', data.IsCurrentVersion === 'True', { silent: true });
            listService.currentForm.model.set('isOrderlyClosed', data.IsOrderlyClosed === 'True', { silent: true });
            listService.currentForm.model.set('version', data.Version, { silent: true });
            listService.currentForm.model.set('appLinkId', linkId, { silent: true });

            // PF-2909: Storing the form name that comes directly from the response for later usage
            listService.currentForm.model.set('name', data.Name, { silent: true });
            listService.currentForm.model.set('formNameFromResponse', data.Name, { silent: true });
            listService.currentForm.model.set('mobileOutsideColor', data.mobileOutsideColor, constants.MODEL_SILENT);
            
            //PF-9539 Add reflow
            listService.currentForm.model.set('reflowEnabled', data.ReflowEnabled === 'True', { silent: true });

            // if (formObj.Form.StartPages) {
            //     listService.currentForm.model.set('StartPages',formObj.Form.StartPages,{silent:true});
            // }

            if (formObj.Form.States) {
                listService.currentForm.model.set('States', formObj.Form.States, { silent: true });
            }

            return p1;
        }

        return accountService.getDetailsForDesigner().then( accountSettings => {
                return accountSettings;
        }).then((accountSettings) => {
            listService.setDocTypeForm();
            listService.resetFormBase();
            //PF-6009 Merge the properties for account Settings to make sure that properties loaded on login are not lost
            listService.accountSettings = {...listService.accountSettings, ...accountSettings};
            console.log(`accountSettings`, listService.accountSettings);
            return new Promise((resolve, reject) => {
                restService.openForm(formId, majorVersion, minorVersion, util.isTrue(comesFromRecovery)).then(data => {

                    const recoveryEnabled = util.isTrue(listService.accountSettings.DesignRecoveryEnabled);
                    if(!util.isEmpty(data.LastRecoveryUpdateDate) && recoveryEnabled){
                        const recoverDate = util.formatUTC(data.LastRecoveryUpdateDate); 
                        const recoverDesignModal = new RecoverDesignModal({model: new Model({ formId: formId, recoverDate: recoverDate, fromAction: "design", lastUpdate: lastUpdate })});
                        recoverDesignModal.render().then(result => {                            
                            if (result === "recover") {
                                restService.openForm(formId, majorVersion, minorVersion, true).then(data2 => {
                                    data2.ComesFromRecovery = true;
                                    listService.dashboardLayout.mainPanelView.model.set('latestVersion', data2.Version, constants.MODEL_SILENT);
                                    const p1 = openForm(data2);
                                    resolve(`${p1} opened`);
                                });
                            } else if (result === "openForm") {
                                const p1 = openForm(data);
                                resolve(`${p1} opened`);
                            }
                        });
                    }
                    else {
                        const p1 = openForm(data);
                        resolve(`${p1} opened`);
                    }
                }, err => {
                    console.log(err);
                    if (err && typeof err === 'string') {
                        reject(err);
                    } else if (err && typeof err === 'object' && err.responseText) {
                        const msg = JSON.parse(err.responseText);
                        reject(`${msg.Message}. ${msg.ExceptionMessage}.`);
                    } else {
                        reject(err);
                    }
                })
            })
        }).catch(err => {
            console.log('Error loading account details', err);
            throw err;
        });
    }


    //======================================================================
    // Call this method to load a remote report. If loading successful,
    // loads form into the UI. Either way, it returns a promise containing
    // completion notification values.
    //
    // PF-1956: Also captures current account detail settings before load.
    //======================================================================
    loadReport(reportId, majorVersion, minorVersion, reportName, reportVersionId, lastUpdate, comesFromRecovery) {

        const openReport = (data) => {
            console.log(`Inbound compressed report: `, data.ReportXML );
            const
                reportXml = util.minifyXMLString(this._decompressForm( data.ReportXML )),
                reportDoc = formulaService.preprocess( reportXml ),
                reportObj = xjService.xmlDocToJs( reportDoc ),
                reportGUID = data.ReportGUID;

            if ( util.isEmpty(reportObj.Report._name)) {
                reportObj.Report._name = data.Name;
            }
            // KEEP THIS LOGGING for now. Useful to visualize what's coming off the wire.
            console.log(`INBOUND REPORT JSON: `, reportObj);

            listService.currentForm = undefined;

            const imJSON = Immutable.Map(reportObj);

            let _majorVersion = majorVersion;
            let _minorVersion = minorVersion;

            if (util.isTrue(data.ComesFromRecovery) && data.Version){
                //Update majorVersion and minorVersion in case it changed after doing a recovery
                let _version = data.Version.split('.');
                if (_version.length === 2){
                    _majorVersion = _version[0];
                    _minorVersion = _version[1];
                }
            }

            this._displayReport(imJSON, {
                reportId: reportId, 
                reportGUID: reportGUID ,
                reportName: reportName,
                reportVersionId: reportVersionId,
                reportMajorVersion: _majorVersion,
                reportMinorVersion: _minorVersion
                } );

            if (reportObj.Report.Parameters) {
                listService.currentForm.model.attributes.Parameters = this._loadParameters(reportObj.Form);
            }

            // Display success banner
            const p1 = `Report "${data.Name} version ${data.Version}"`;

            listService.currentForm.model.set('isDeployedVersion', data.IsDeployedVersion === 'True', { silent: true });
            listService.currentForm.model.set('isCurrentVersion', data.IsCurrentVersion === 'True', { silent: true });
            listService.currentForm.model.set('isOrderlyClosed', data.IsOrderlyClosed === 'True', { silent: true });
            listService.currentForm.model.set('version', data.Version, { silent: true });
            listService.currentForm.model.set('name', data.Name, { silent: true });

            // KEEP THIS LOGGING for now. Useful to quickly visualize what we understood came off the wire.
            console.log(`REPORT - What's loaded: `, listService );
            console.log(`\tpages: `, listService.pageList.toJS() );
            console.log(`\tobjs: `, listService.objectList.toJS() );

            //listService.setDirty();  // For time-being, any loaded document is dirty.  2016-05-06

            listService.currentForm.model.set('formNameFromResponse', data.Name, {silent:true});

            return p1;
        };

        return accountService.getDetailsForDesigner().then( accountSettings => {
            return accountSettings;
        }).then(  (accountSettings) => {
            listService.setDocTypeReport();
            listService.resetFormBase();
            //PF-6009 Merge the properties for account Settings to make sure that properties loaded on login are not lost
            listService.accountSettings = {...listService.accountSettings, ...accountSettings};
            console.log(`accountSettings for report`, listService.accountSettings);
            return new Promise((resolve, reject) => {
                listService.resetFormBase();

                restService.openReport(reportId, majorVersion, minorVersion, util.isTrue(comesFromRecovery)).then(
                    data => {
                        const recoveryEnabled = util.isTrue(listService.accountSettings.DesignRecoveryEnabled);
                        if(!util.isEmpty(data.LastRecoveryUpdateDate) && recoveryEnabled){
                            const recoverDate = util.formatUTC(data.LastRecoveryUpdateDate); 
                            const recoverDesignModal = new RecoverDesignModal({model: new Model({ formId: reportId, recoverDate: recoverDate, fromAction: "design", lastUpdate: lastUpdate  })});
                            recoverDesignModal.render().then(result => {                            
                                if (result === "recover") {
                                    restService.openReport(reportId, majorVersion, minorVersion, true).then(data2 => {
                                        data2.ComesFromRecovery = true;
                                        listService.dashboardLayout.mainPanelView.model.set('latestVersion', data2.Version, constants.MODEL_SILENT);
                                        const p1 = openReport(data2);
                                        resolve(`${p1} opened`);
                                    });
                                } else if (result === "openForm") {
                                    const p1 = openReport(data);
                                    resolve(`${p1} opened`);
                                }
                            });
                        }
                        else {
                            const p1 = openReport(data);
                            resolve(`${p1} opened`);
                        }

                    }, err => {
                        console.log(err);
                        if (err && typeof err === 'string') {
                            reject(err);
                        } else if (err && typeof err === 'object' && err.responseText) {
                            const msg = JSON.parse(err.responseText);
                            reject(`${msg.Message}. ${msg.ExceptionMessage}.`);
                        } else {
                            reject(err);
                        }
                    });
            });
        },err => { 
            reject(err);
        });
    }


    //=======================================================
    // Helper used during initial doc load (form or report)
    //=======================================================
    _storeBaseDocAttrs(v, k) {
        if (this.validDocAttributes.has(k)) {
            const model = listService.currentForm.model;
            model.set(k, v, SILENT);
            listService.formBase[k] = v;

            //console.log(`|||==> to reportBase ${k}:`, v);
        } else {
            console.log(`>>>> NOT MATCHED. FIX IT! `, k, v);
        }
    }


    //======================================================================
    // Central dispatcher to un-marshal and load inbound FORM XML object.
    // SILENT shuts down the form event system while assembling the form.
    //======================================================================
    async _loadForm(formObj, opts ) {
        //console.log('_loadForm ' + Date());
        listService.reset( SILENT);

        const form = Immutable.Map(formObj.get('Form'));

        $("#aForm").hide();   

        this.loadedNotifications = [];

        //PF-9501 Load web fonts list
        fontService.getWebFonts();
      
        // Extract form components; build a representation in the listService.
        if (!form || !form.map) {
            throw (`PANIC! map item undefined in persistence _loadForm disptachFn`);
        } else {

            // PF-4862 Common element-loader dispatch function
            const doLoadElement = (v,k) => {
                if (typeof this.disp.get(k) === 'function') {
                    const retVal = this.disp.get(k)(v);
                } else {
                    this._storeBaseDocAttrs( v, util.trimLeadingUnderscore(k) );
                }
            };

            assetCollection.reset();

            // PF-4862 store any work-flows first while enforcing D.R.Y.
            const workflow = 'Workflow';
            form.filter((v,k)  => v && k === workflow).map((v, k) => doLoadElement(v, k) );
            // Process the rest of the item according to its contents
            form.filter((v,k)  => v && k !== workflow).map((v, k) => doLoadElement(v, k) );
        }
        // Override what we saw in the XML with what is specified to Load.
        // The load can sometimes have the ID from a copied form, until it is saved again.
        listService.setDocTypeForm();
        listService.formBase.guid               = opts.formGUID;
        listService.formBase.id                 = opts.formId;
        listService.formBase.linkId             = opts.formLinkId;
        listService.formBase.formVersionId      = opts.formVersionId;
        listService.formBase.name               = opts.formName;
        listService.currentForm.model.set('id', opts.formId, SILENT);
        listService.currentForm.model.set('guid', opts.formGUID, SILENT);
        listService.formBase.majorVersion       = opts.formMajorVersion;
        listService.formBase.minorVersion       = opts.formMinorVersion;

        //check for NULL form name, this happens on NEW Forms before they are opened for the first time.
        if (listService.currentForm.model.get('name') === 'null') {
            listService.currentForm.model.set('name', opts.formName, SILENT);
        }

        listService.updateObject( constants.FORM_RAW_ID, listService.currentForm, {silent:true} );

        this._loadFormEvents(form);

        //sequenceService.setUsedDOMNumbers();
        listService._currentBehaviorInstanceId = undefined;

        // Closing ...
        let self = this;
        setTimeout(function () {
            self._finishLoading( form );                  
        }, 0);

       await mobileService.initializeMobileData();
       eventBus.trigger(constants.EV_VALIDATE_PULSE_ICON_EVENT);
    }


    //======================================================================
    // Central dispatcher to un-marshal and load inbound REPORT XML object.
    // SILENT shuts down the form event system while assembling the form.
    //======================================================================
    _loadReport(reportObj, opts ) {

        listService.reset( SILENT);
 
        const report = Immutable.Map(reportObj.get('Report'));

        // Extract form components; build a representation in the listService.
        if (!report || !report.map) {
            throw (`PANIC! map item undefined in persistence _loadReport disptachFn`);
        } else {
            // Process the item according to its contents
            report.map( (v, k) => {
                if (v) {
                    if (typeof this.disp.get(k) === 'function') {
                        //console.log(`dispatch ${k} = `, v);
                        const retVal = this.disp.get(k)(v);
                    } else {
                        // console.log(`_loadReport(reportObj) storing report attribute: `, k, v);
                        this._storeBaseDocAttrs( v, util.trimLeadingUnderscore(k) );
                    }
                }
            });
        }

        // Override what we saw in the XML with what is specified to Load.
        // The XML can sometimes have the ID from a copied form, it is saved again.
        listService.setDocTypeReport();
        listService.formBase.guid = opts.reportGUID;
        listService.formBase.id = opts.reportId;
        listService.formBase.name               = opts.reportName;
        listService.formBase.formVersionId      = opts.reportVersionId;
        listService.currentForm.model.set('id', opts.reportId, SILENT);
        listService.currentForm.model.set('guid', opts.reportGUID, SILENT);


        //check for NULL form name, this happens on NEW Forms before they are opened for the first time.
        if (listService.currentForm.model.get('name') === 'null') {
            listService.currentForm.model.set('name', opts.reportName, SILENT);
        }

        listService.updateObject( constants.FORM_RAW_ID, listService.currentForm, SILENT );
        
        this._loadFormEvents(report);

        listService._currentBehaviorInstanceId = undefined;

        console.log(`REPORT formBase`, listService.formBase);

        // Closing ...
        this._finishLoading( report );
    }

    _resizeEditor() {
        util.makePanelFit();
    }

    //======================================================================
    // Sync loaded components, then position to start page
    //======================================================================
    _finishLoading( form ){
        console.log('_finishLoading ' + Date());
        listService.firstLoad = true;
        LeftPanelStateService.resetTree();
        
        // 1. Sync models in one go -- we were SILENT during construction churn
        eventBus.trigger(constants.EV_FORM_LOADED);

        listService.loading = false;
        pageSyncService.sync(pageCollection);
        // Notify that form loading has finished
        //eventBus.trigger(constants.EV_PAGES_UPDATED);
        //viewManager.thumbnailListView.render();

        // 2. Sync the page DOMs, ending with the first thumbnail selected
        // (Here's where to capture the thumbnail picture if that JIRA story pops up)
        // Thumbnails are not implemented yet, performance dragging
        /*
        listService.pageList.reverse().map(( v, k ) => {
            pageSyncService.selectThumbNail( k );
        });
        */

        // 3. Find start page ID
        listService.noPages = false;
        let startPageId = listService.pageList.size>0 ? listService.pageList.first().id : '';
        if (startPageId === ''){
            eventBus.trigger('hideCanvas');
            listService.noPages = true;
        }


        // Dont believe the Start Page is used in the Editor just set here. PF-1637
        //let startPageId = self._extractStartPageId( form );
        self._extractStartPageId( form );
        if ( startPageId ) {

            startPageId = listService.cleanId(startPageId);

            listService.currentPageId = startPageId;
            viewManager.thumbnailListView.render();

            // 4.5 Kick the page display for single page form.
            //listService.currentPageId = undefined;
            const isFirstLoad = true;
            pageSyncService.displayPage(startPageId, isFirstLoad);


            // 5. Scroll selected thumbnail into view
            const pg = $(constants.THUMBPANE_SELECTED)[0];
            if (pg ) {
                pg.scrollIntoView(true);

                // 6. Slide 'er down a smidge
                const $tnpane = $(constants.THUMBNAIL_PANE);
                $tnpane.scrollTop(Math.max($tnpane.scrollTop() - 26, 0));
            }

        }

        //pageSyncService.sync(pageCollection);

        this._resizeEditor();
        listService.currentId = undefined;

        setTimeout(function () {
            eventBus.trigger('selectForm');
        }, 100);

        userService.checkUserSession();

        undoService.clear();
        eventBus.trigger('undoCacheEvent');

         //Load tour
        setTimeout(function () {

            const tourTag = sessionStorage.getItem('appTourTag');
            const uS = listService.userSettings.get(tourTag);
            if (uS) { //If the tour exists
                const tourOpts = JSON.parse(uS);

                if (tourOpts && util.isTrue(tourOpts.show) && !util.isTrue(tourOpts.complete)) {
                    TourService.initTour('walkthrough');
                }
            }
        }, 500);


    }

    //======================================================================
    // Returns start page ID or undefined
    //======================================================================
    _extractStartPageId( form ) {
        let pageId = 'default';
        if (form.has('StartPages')) {
            pageId = form.get('StartPages')['StartPage']['_value'];

            listService.currentForm.model.set("startPage",pageId,SILENT);

            try {
                // Yup, it comes from the server as "default;"
                const gotoId = pageId !== 'default' ? pageId : listService.pageList.first().id;
                pageId = gotoId;
            } catch( err ){
                console.log('ignoring', err);
            }
        }
        return pageId;
    }


    //======================================================================
    // Load the pages, like it says.
    // Assumes we load pages before their objects.
    //======================================================================
    _loadPages( obj ){

        const createPage = (item, k) => {
            //console.log(`createPage page obj: `, item);

            // Create new page in backing list, making it the current page. Also passing in the ID from the server.
            // TODO - Need flag for LOADING, so we don't display and render all pages and contents.
            var view = pageInstanceFactory.createView('page_instance', 'addPage', undefined,  item._id, true);

            // Set pageTitle for thumbnail from inbound name attribute.
            view.model.set('pageTitle', item._name, SILENT);
            view.model.set('name', item._name, SILENT);
            //listService.pageList.get(item._id).model.set('pageTitle', item._name);

        };

        listService.clearPages( SILENT );
        if ( Array.isArray( obj.Page )) {
            Immutable.List(obj.Page).map( v => createPage(v) );
        } else {
            // obj.Page not an array; is a solid page item
            createPage( obj.Page, {} );
        }
        
        // Uncomment to list loaded pages;
        //console.log('***** Loaded pages by raw ID:');
        /*listService.pageList.map( (v, k) => {
            console.log(`\t${k}: `, v);
        });*/
    }


    //======================================================================
    // Load the workflow, if any
    //======================================================================
    _loadWorkflow( obj ) {
        // store Worklfow  values
        const
            paths = obj.Paths,
            roles = obj.Roles,
            wprops = obj.Properties;

        // Store root wf props
        listService.setWorkflowProperties(
            { width: wprops._width, height: wprops._height, defaultStageId: wprops._defaultStageId } );

        // Store Roles
        // PF-4862 always an array. Could be empty.
        util.enforceArrayType(roles.Role).filter( v => v && v._id).map( v => {
            const role = {};
            role.id = v._id;
            role.name = v._name;

            role.personName = v.Properties._personName;
            role.personId   = v.Properties._personId;
            role.personType = v.Properties._personType;

            role.defaultPerson  = role.personName;

            let roleType ="";
            switch (role.personType) {
               case "0":
                   roleType = "";
                   break;
               case "1":
                   roleType = "user";
                   break;
               case "2":
                   roleType = "position";
                   break;
               case "3":
                   roleType = "fixedEmail";
                   role.defaultPerson  = v.Properties._personId;
                   role.personName = "";
                   break;
               case "4":
                   roleType = "userGroup";
                   break;
               case "5":
                   roleType = "fieldEmail";
                   break;
            }

            role.userRoleType   = roleType;

            listService.addWorkflowRole(role);
        });     

        const
            Comment = 'Comment', Stage = 'Stage',
            kinds = [ Comment, Stage],
            factMap = { Comment: 'workflow_comment', Stage: 'workflow_stage' };

        // Store any comments and stages
        _.forEach(kinds, kind =>
            _.forEach( util.enforceArrayType(obj.Stages), st =>
                _.forEach( util.enforceArrayType(st[kind]), (v, k) => {
                    if (v) {
                        const
                            p = v.Properties,
                            pos = {left: Number(p._x), top: Number(p._y)},
                            factoryKey = factMap[kind],
                            factoryParams = factoryService.workflowFactories[factoryKey],
                            widget = factoryParams.factory.createWorkflowView(factoryKey, pos, v._id);

                        widget.model.set({width: p._width, height: p._height}, SILENT);

                        if (kind === Comment) {
                            widget.model.set({'type': 'comment', 'text': p._text}, SILENT);
                        } else if (kind === Stage) {
                            widget.model.set({
                                'type': 'stage',
                                'name': util.restoreSingleQuotes(p._name),
                                'description': p._description,
                                'isClosed': p._isClosed,
                                'isDefault': wprops._defaultStageId === widget.model.get('id')
                            }, SILENT);
                        }

                        listService.addWorkflowObject(widget, {noAutoSuffix: true});
                    }
                })
            )
        );

        // <Workflow Paths (connections)
        // <Paths>
        //     <Path id="6HtYJAAAQqYAANsDAAAd4Nbfots=" type="workflowconnector">
        //         <Properties sourcePoint="4" textBoxWidth="80" sourceShape="ow4NwQAAyLIAAMq5AABmP5mj5Eo=" targetPoint="10" ctrlPoint2x="" ctrlPoint1x="" textBoxHeight="4" targetShape="PF_58" lineType="straight" name="" ctrlPoint1y="" ctrlPoint2y="" />
        //         <Parameters>
        //             <Parameter id="default" type="expression" literal="null" field="null" special="null">
        //                 <Expression id="djoqMgAAzi0AAGmjAADlrVdipsM=" type="scriptingCondition">
        //                 <Argument id="OylKWgAAa/wAAIJuAACYe6SXde8=" type="scripting_literal" value="'string'" />
        //                 <Operator id="vAweggAAC8wAAFfDAAAf27TXlyE=" type="==" />
        //                 <Argument id="FVmMPAAA6t0AAG3wAABJVgHnBk4=" type="scripting_date" value="2016-09-01 00:00:00" />
        //                 </Expression>
        //             </Parameter>
        //         </Parameters>
        //     </Path>
        //     <Path id="darUywAAcQQAAE24AADleJevQok=" type="workflowconnector">
        //         <Properties sourcePoint="4" textBoxWidth="80" sourceShape="GYnKDAAAPBkAAOLyAADP4YpLpnE=" targetPoint="10" ctrlPoint2x="" ctrlPoint1x="" textBoxHeight="4" targetShape="E4ZiKwAA3k4AAFSdAAA825FzeDg=" lineType="straight" name="" ctrlPoint1y="" ctrlPoint2y="" />
        //     </Path>
        //      <Path id="ptu3GAAAlYYAAC0XAADthqFcvlM=" type="workflowconnector">
        //         <Properties sourcePoint="4" textBoxWidth="80" sourceShape="E4ZiKwAA3k4AAFSdAAA825FzeDg=" targetPoint="10" ctrlPoint2x="" ctrlPoint1x="" textBoxHeight="24" targetShape="ow4NwQAAyLIAAMq5AABmP5mj5Eo=" lineType="straight" name="Path 2" ctrlPoint1y="" ctrlPoint2y="" />
        //     </Path>
        // </Paths>

        // We used to map stage pts 0..11 to NESW points 0..4
        //              0, 0, 0, 1, 1, 1, 2, 2, 2, 3, 3, 3
        //              0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10,11
        // But in PF-3551 we load them 1:1
        const inmap = [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10,11 ];


        if (paths) {
            _.forEach(util.enforceArrayType(paths.Path), v => {
                const
                    path = {id: v._id, type: v._type, Properties: {}},
                    vp = v.Properties,
                    name = vp._name || EMPTY,
                    src = listService.getWorkflowStageOrComment(vp._sourceShape),
                    dest = listService.getWorkflowStageOrComment(vp._targetShape),
                    srcDot = inmap[Number(vp._sourcePoint)] ,
                    destDot = inmap[Number(vp._targetPoint)] ,
                    opts = {id: v._id, scriptId: ""};

                const connectionVO = new ConnectionVO(src, dest, srcDot, destDot, opts);

                const lModel = new LineModel({ name: v.Properties._name, srcDot: v.Properties._sourcePoint, destDot: v.Properties._targetPoint, text: vp._text });
                lModel.attributes.id =  connectionVO.id;
                lModel.attributes.srcWidgetModel = src.model;
                lModel.attributes.destWidgetModel = dest.model;
                lModel.attributes.text = vp._text;
                lModel.attributes.textBoxWidth = vp._textBoxWidth;

                // PF-2345 Preserve curved line inbound
                FormLoadService.loadPathLineProps(lModel, vp);

                if (v.Parameters) {
                    let params = {};
                    params.Parameter = [];
                    let param = {};
                    let args = [];

                    if (Array.isArray(v.Parameters.Parameter) ) {
                        _.forEach(v.Parameters.Parameter, (p) => {
                            args = [];
                            param = util._unPrefix(p);
                            if (param.EXPR) {
                                self._loadExpression(param.EXPR, args);

                                param.Expression = { id: param.EXPR._id, type: param.EXPR._type };
                                param.Expression.arguments = args;
                            }

                            params.Parameter.push(param);
                        });

                    } else {
                        param = util._unPrefix(v.Parameters.Parameter);
                        if (param.EXPR) {
                            self._loadExpression(param.EXPR, args);

                            param.Expression = { id: param.EXPR._id, type: param.EXPR._type };
                            param.Expression.arguments = args;
                        }

                        if (typeof param.id !== 'undefined' && param.Expression && typeof param.Expression.id !== 'undefined' ){
                           params.Parameter.push(param);
                        }
                        
                    }
                    lModel.set('Parameters', params, SILENT);

                }

                connectionVO.model = lModel;

                // PF-2345 pull copies of line parameters up to connectionVO body
                FormLoadService.reflectModelToConnectionVO(connectionVO);

                self._createBehaviorInstanceForWorkflow(v, v._id);

                listService.addWorkflowPath(connectionVO);

    console.log(`WF xml PATH stored`,
        listService._workflow.paths.get(connectionVO.id));

            });
        }

    }


    //======================================================================
    // Load the dependencies
    //======================================================================
    _loadDependencies( obj  ){

        if ( Array.isArray( obj.Dependency )) {
            _.forEach(obj.Dependency, (dep) =>  {
                listService.addDependency( util._unPrefix( dep ));
            });
        } else {
            listService.addDependency( util._unPrefix( obj.Dependency ));
        }
    }


    //======================================================================
    // Overrides the default theme with the theme sent by obj.Properties
    //======================================================================
    _loadTheme( obj ){
        themeService.reset();

        const props = Immutable.Map( obj.Properties );
        props.map( (v, k ) => {
            const key = `${k.replace(/_/, '~')}`;

            // Add leading '#' if value matches a legal color value
            let v2 = util.isCssHexColor(v) ? constants.STRING_HASH + v : v;

            if (key === '~groupBorder') {
                let propArray = v2.split(',');
                if (propArray.length === 2) {
                    v2 += ',0';
                }
            }

            themeService.updateItem (v2, key);
        });

    }


    //======================================================================
    // Load the parameters of a Form
    //======================================================================
    _loadParameters( obj ){

        if (obj.Parameter) {
            let params = {};
            params.Parameter = [];
            let param = {};
            let args = [];
            if (Array.isArray(obj.Parameter) ) {
                _.forEach(obj.Parameter, (p) => {
                    args = [];
                    param = util._unPrefix(p);
                    if (param.EXPR) {
                        self._loadExpression(param.EXPR, args);

                        param.Expression = { id: param.EXPR._id, type: param.EXPR._type };
                        param.Expression.arguments = args;
                    }

                    if (typeof param.id !== 'undefined') { //PF-5050; There shouldn't be parameters without id attribute because it is expected in back-end
                        params.Parameter.push(param);
                    }
                });

            } else {
                param = util._unPrefix(obj.Parameter);
                if (param.EXPR) {
                    self._loadExpression(param.EXPR, args);
                    param.Expression = { id: param.EXPR._id, type: param.EXPR._type };
                    // noinspection JSAnnotator
                    param.Expression.arguments = args;
                }
                if (typeof param.id !== 'undefined') { //PF-5050; There shouldn't be parameters without id attribute because it is expected in back-end
                    params.Parameter.push(param);
                }
            }
            

            listService.currentForm.model.attributes.Parameters = params;
            //return params;
        }

    }


    //======================================================================
    // Load the properties (form properties)
    //======================================================================
    _loadProperties( obj ){

        const fProps = util._unPrefix(obj);
        for (var p in fProps) {
            if (fProps.hasOwnProperty(p)) {
                let val = fProps[p];
                if (val && p.toLowerCase().includes('color')) {
                    fProps[p] = util._fixColorFormat(fProps[p]);
                }

                if(val && p.toLowerCase().includes('rtl') && val === 'checked'){
                    fProps[p] = true;
                }
            }
        }

        listService.currentForm.model.set( fProps, SILENT);

        // Note: if we need more parameters set in this manner, we should implement something like this:
        //      eventBus.trigger('formProps', { prop1: '', prop2: '', ....} );
        // i.e. one event -> many properties set
        // Meanwhile  ...

        // Set physical page props into the DOM here. Values are for all pages of a form.
        let hideShowGrid=util.isTrue(userService.userSettings.attributes._edShGrid);
        eventBus.trigger('formWidthSet', obj._width);
        eventBus.trigger('formHeightSet', obj._height);
        eventBus.trigger('gridWidthSet', obj._gridWidth);
        eventBus.trigger('gridHeightSet', obj._gridHeight);
        eventBus.trigger('gridSizeSet', hideShowGrid);
        eventBus.trigger('dropShadowSet', obj._shadow);

    }


    //======================================================================
    // Load the StartPages incantation
    //======================================================================
    _loadStartPages( obj ){
        if (obj.StartPage) {
            const sps = [];
            util.enforceArrayType(obj.StartPage).forEach(item => sps.push( { id: item._id, value: item._value } ) );
            listService.currentForm.model.set('StartPages', {'startPage': sps }, constants.MODEL_SILENT );
            listService.isMobileOpen = false;
            console.log(`=> startPages`, listService.currentForm.model.get('StartPages') );
        }

    }


    // Pre-resolve theme values here until we can handle theme indirection in properties
    // FN:
    _condApplyTheme( v ) {
        const v2 = themeService.resolve( v );
        return v2 ? v2 : v;
    }

    //======================================================================
    // FN: Return new props, after stripping keys' leading underscores;
    //======================================================================
    _XXunPrefix( props ) {
        const p = Immutable.Map( ).asMutable();

        Immutable.Map( props ).map( (v,k) => {
            //const v2 = this._condApplyTheme( v );

            if (k) {
                p.set(k.replace(constants.XATTR_PREFIX, constants.STRING_EMPTY), v);
            }
        });
        const pj = p.toJS();
        return pj;
    }

    _XXXfixColorFormat( color ) {
        let newValue = color;

        if (newValue) {
            if (newValue.length > 1) {
                if ( (newValue.substring(0,1) !== '#') && (newValue.substring(0,1) !== '~') ) {
                    newValue = '#' + newValue;
                }
            }
        }

        return newValue;
    }

    _loadExpressionItem( item, isDataSource = false ) {
        let arg = {};

        switch (item._baseName) {
            case "Argument":
                arg.id = listService.cleanId( item._id );
                arg.kind = 'argument';
                arg.type = item._type;
                switch(arg.type){
                    case 'scripting_date':
                        // convert date to d MM yy 
                        if (item._value === 'now') {
                            arg.value = '[current]';
                        }
                        else {
                            arg.value = util.formatExpressionDate(item._value);
                        }
                        break;
                    case 'scripting_literal':
                    case 'scripting_literal_text':
                    case 'scripting_literal_num':
                    case 'scripting_formField':
                        arg.value = item._value;
                        // Next assignment probably doesn't make sense, but we don't want to break something
                        //  Resolving PF-2079
                        arg.fieldId = item._value;
                        break;
                    case 'scripting_boolean':
                    case 'scripting_special':
                        arg.value = item._value;
                        break;
                    case 'reporting_boolean':
                        arg.value = new Set(['true', 'yes', 'checked']).has(item._value.toString().toLowerCase()) ? 'true' : 'false';
                        arg.dataType = item._dataType;
                        break;
                    case 'reporting_string':
                    case 'reporting_number':
                    case 'reporting_date':
                        arg.value = item._value;
                        if (item._value === 'now') {
                            arg.value = '[current]';
                        }
                        arg.dataType = item._dataType;
                        break;
                    case 'reporting_datasourceField':
                        arg.value = item._value;
                        arg.dataType = item._dataType;
                        arg.caption = item._caption;
                        break;
                    default:
                        arg.fieldId = item._value;
                        break;
                }
                break;
            case "Operator":
                arg.id = listService.cleanId( item._id );
                arg.kind = 'operator';
                arg.type = item._type;
                arg.value = this._determineOperatorValue( item._type );
                break;
            case "Function":
                const type = item._type
                arg.id = listService.cleanId( item._id );
                arg.kind = 'function';
                arg.type = !type.includes("script_") ? `script_${type}` : type;
                arg.value ='';
                arg.functionName = formulaService.getFunctionName(arg.type);
                if (item.EXPR) {
                    const _args = [];
                    this._loadExpression( {EXPR: item.EXPR }, _args, isDataSource);
                    // call to formulaService to build these based on type.
                    // get array of Parameters from formulaService
                    // Loop through each Parameter, adding a "functionParameter" to the Array, the children attribute should be the corresponding _arg[i]
                    arg.functionParameters = [];
                    const funParms = formulaService.getFunctionParameters(arg.type, isDataSource);
                    _.forEach(funParms, function(p, index) {
                        let children = _args[index].children || [_args[index]];
                        arg.functionParameters.push( {name: p, children: children });
                    });
                }
                break;
            case "Expression":
                if (item._type === 'reportingFilter'){
                    arg.id = listService.cleanId( item._id );
                    arg.type = 'reportingFilter';
                    arg.kind = 'grouping';
                    const childArgs = [];
                    this._loadExpression({EXPR: item.EXPR}, childArgs, isDataSource);
                    arg.arguments = childArgs;
                    arg.children = childArgs;
                }else {
                    arg.id = listService.cleanId( item._id );
                    arg.kind = 'grouping';
                    arg.type = 'grouping';
                    arg.value ='';
                    const childArgs = [];
                    this._loadExpression({EXPR: item.EXPR}, childArgs, isDataSource);
                    arg.children = childArgs;
                }
                break;
        }

        return arg;
    }

    _loadExpression (expression, args, isDataSource = false) {
        let arg = {};
        const self = this;

        if (expression.EXPR) {
            // Loop through items in Expression
            if (Array.isArray(expression.EXPR)) {
                _.forEach(expression.EXPR, function (item) {
                    arg = self._loadExpressionItem(item, isDataSource);
                    args.push(arg);
                });
            } else {
                  arg = this._loadExpressionItem(expression.EXPR, isDataSource);
                //   if (expression.EXPR._type === 'reportingFilter'){
                //      return arg;
                //   }

                 args.push(arg);
            }
        }
    }

    //======================================================================
    // Object loader: loads one object; recurses on groups and nested groups.
    //======================================================================
    _recursiveObjectLoader(obj, pageId ) {
        let view = undefined;

        const
            cProps = util._unPrefix(obj.Properties),
            cName = obj._name,
            cId = obj._id,
            cType = obj._type,
            factories = factoryService.factories,
            factoryKey = typeIndex.get(cType),
            factoryItem = factories[factoryKey];


        if ( factoryItem ) {
            const
                factory = factoryItem.factory,
                pos = {left: cProps.left, top: cProps.top, id: listService.cleanId(cId), loading:true };

            view = factory.createView(factoryKey, pos);
            view.id = listService.cleanId(cId);
            view.model.set('id', view.id, SILENT);

            const
                model = view.model,
                mergedProps = _.merge(cProps, {'pageId': pageId, 'name': cName, 'pfType': cType, 'id': view.id});

            //handle font properties
            if (mergedProps.font) {
                const fonts = mergedProps.font.trim().split(',');
                
                if (fonts[0]) {
                    mergedProps.fontFamily = fonts[0];

                    const webFont = fontService.webFonts.find(font => font.name === fonts[0]);

                    if(webFont){
                        fontService.loadWebFontResource(webFont);
                    }
                }
                if (fonts[1]) {
                    mergedProps.fontSize = fonts[1];
                }
                if (fonts[2]) {
                    mergedProps.textWeight = fonts[2] + ' !important';
                }

                mergedProps.textStyle = fonts[3] ? fonts[3] + ' !important' : 'normal !important';


            }

            if (mergedProps.buttonFont) {
                const fonts = mergedProps.buttonFont.split(',');
                if (fonts[0]) {
                    mergedProps.buttonFontFamily = fonts[0];
                }
                if (fonts[1]) {
                    mergedProps.buttonFontSize = fonts[1];
                }
                if (fonts[2]) {
                    mergedProps.buttonTextWeight = fonts[2] + ' !important';
                }

                if (fonts[3]) {
                    mergedProps.buttonTextStyle = fonts[3] + ' !important';
                }

            }

            if (mergedProps.headerFont) {
                const fonts = mergedProps.headerFont.split(',');
                if (fonts[0]) {
                    mergedProps.headerFontFamily = fonts[0];
                }
                if (fonts[1]) {
                    mergedProps.headerFontSize = fonts[1];
                }
                if (fonts[2]) {
                    mergedProps.headerTextWeight = fonts[2] + ' !important';
                }

                if (fonts[3]) {
                    mergedProps.headerTextStyle = fonts[3] + ' !important';
                }

            }

            if (mergedProps.titleFont) {
                const fonts = mergedProps.titleFont.split(',');
                if (fonts[0]) {
                    mergedProps.titleFontFamily = fonts[0];
                }
                if (fonts[1]) {
                    mergedProps.titleFontSize = fonts[1];
                }
                if (fonts[2]) {
                    mergedProps.titleTextWeight = fonts[2] + ' !important';
                }

                if (fonts[3]) {
                    mergedProps.titleTextStyle = fonts[3] + ' !important';
                }

            }

            if (mergedProps.border) {
                
                const border = mergedProps.border.split(',');     
                                
                 //PF-5630 Fix in case the border value does not have the radius, if this value is missing it causes problems with the print function
                 if(border.length < 3 && !themeService.isThemeProperty(mergedProps.border) && !mergedProps.cornerRadius){ //PF-5885 - Backwards compatibility - Button Corner Radius is not saved
                    border.push("0");
                    mergedProps.border = border.join(',');
                }

                if (border[0]) {
                    mergedProps.borderSize = border[0];
                }
                if (border[1]) {
                    mergedProps.borderStyle = border[1];
                }
                if (border[2]) {
                    mergedProps.cornerRadius = border[2];
                }

                //PF-6229 Date Input or drop down corner radius should not be set from the theme, this is causing print to fail
                if (themeService.isThemeProperty(mergedProps.cornerRadius) && (obj._type === constants.CONTROL_TYPE_DATEINPUT || obj._type === constants.CONTROL_TYPE_DROPDOWN)) {
                    mergedProps.cornerRadius = 0;
                }
                
            }

            // loop through all colors and fix format
            for (let p in mergedProps) {
                if (mergedProps.hasOwnProperty(p)) {
                    let val = mergedProps[p];
                    if (val && p.toLowerCase().includes('color')) {
                        mergedProps[p] = util._fixColorFormat(mergedProps[p]);
                    }
                    // PF-1968 Change for Z-index negative values.
                    // if (val && p.toLowerCase() === 'zorder') {
                    //     mergedProps[p] = val > -1 ? val : 1;
                    // }
                }
            }

            // general Colors
            //mergedProps.lineColor = util._fixColorFormat(mergedProps.lineColor);
            //if (mergedProps.barColor) {
             //   mergedProps.barColor = util._fixColorFormat(mergedProps.barColor);
            //}

            //PF-8437 This patch is used to remove the value "checked" and replace it for true, this is an old bug that affects filters in reports and some forms might have the issue. 
            const filterProperties = ['setDynamicFilter', 'additiveDynamicFilter', 'respectDynamicFilter', 'ignoreNull', 'linksNewWindow'];
            filterProperties.forEach((prop) => {
                if(mergedProps.hasOwnProperty(prop)){
                    let val = mergedProps[prop];
                    if(val === "checked"){
                        val = true;
                    }
                    else if(val === ""){
                        val = false;
                    }
                    mergedProps[prop] = val;
                }
            });

            // color mapping
            mergedProps.styleColorText = util._fixColorFormat(mergedProps.textColor);
            mergedProps.styleColorTextDown = util._fixColorFormat(mergedProps.textDownColor);
            mergedProps.styleColorTextOver = util._fixColorFormat(mergedProps.mouseOverTextColor);

            //mergedProps.advancedBgColor = util._fixColorFormat(mergedProps.backgroundColor);
            mergedProps.advancedBgGradientColor = util._fixColorFormat(mergedProps.bgGradientColor);
            mergedProps.advancedBgColorOver = util._fixColorFormat(mergedProps.mouseOverColor);
            mergedProps.advancedBgGradientColorOver = util._fixColorFormat(mergedProps.bgGradientOverColor);
            mergedProps.advancedBgColorDown = util._fixColorFormat(mergedProps.backgroundDownColor);
            mergedProps.advancedBgGradientColorDown = util._fixColorFormat(mergedProps.bgGradientDownColor);

            if (obj.Parameters) {
                let params = {};
                params.Parameter = [];
                let param = {};
                let args = [];
                if (Array.isArray(obj.Parameters.Parameter) ) {
                    _.forEach(obj.Parameters.Parameter, (p) => {
                        args = [];
                        param = util._unPrefix(p);
                        if (param.EXPR) {
                            self._loadExpression(param.EXPR, args);

                            param.Expression = { id: param.EXPR._id, type: param.EXPR._type };
                            param.Expression.arguments = args;
                        }

                        if (typeof param.id !== 'undefined') { //PF-5050; There shouldn't be parameters without id attribute because it is expected in back-end
                            params.Parameter.push(param);
                        }                       
                    });
                } else {
                    param = util._unPrefix(obj.Parameters.Parameter);
                    if (param.EXPR) {
                        self._loadExpression(param.EXPR, args);
                        param.Expression = { id: param.EXPR._id, type: param.EXPR._type };
                        param.Expression.arguments = args;
                    }

                    if (typeof param.id !== 'undefined') { //PF-5050; There shouldn't be parameters without id attribute because it is expected in back-end
                        params.Parameter.push(param);
                    }
                }

                mergedProps.Parameters = params;
            }


            // # PF-1951 Old Implementation for Loading Custom Parameters.
            // if (obj.CustomParameters) {
            //     let CustomParameters = {};
            //
            //     if (Array.isArray( obj.CustomParameters.parameter )) {
            //         CustomParameters.parameter = obj.CustomParameters.parameter;
            //     } else {
            //         CustomParameters.parameter = [ obj.CustomParameters.parameter ];
            //     }
            //
            //     mergedProps.CustomParameters = CustomParameters;
            // }

            // # PF-1951 Loading Custom Parameters
            if (obj.CustomParameters) {
                let CustomParameters = {};
                CustomParameters.parameter = [];
                //let params = {};
                //params.Parameter = [];
                let param = {};
                let args = [];


                if (Array.isArray(obj.CustomParameters.parameter)) {
                    //CustomParameters.parameter = v.CustomParameters.parameter;
                    _.forEach(obj.CustomParameters.parameter, (p) => {
                        args = [];
                        //param = util._unPrefix(p);
                        param = p;
                        if (param.EXPR) {
                            self._loadExpression(param.EXPR, args);

                            param.Expression = {id: param.EXPR._id, type: param.EXPR._type};
                            param.Expression.arguments = args;
                        }

                        CustomParameters.parameter.push(param);
                    });
                } else {
                    //CustomParameters.parameter = [ v.CustomParameters.parameter ];
                    //param = util._unPrefix(v.CustomParameters.parameter);
                    param = obj.CustomParameters.parameter;
                    if (param.EXPR) {
                        self._loadExpression(param.EXPR, args);

                        param.Expression = {id: param.EXPR._id, type: param.EXPR._type};
                        param.Expression.arguments = args;
                    }

                    CustomParameters.parameter.push(param);
                }
                mergedProps.CustomParameters = CustomParameters;
            }

            if (obj.Obligatories) {
                let obligatories = new Map();
                let mandatory = {};
                if (Array.isArray(obj.Obligatories.Obligatory) ) {
                    _.forEach(obj.Obligatories.Obligatory, (m) => {
                        mandatory = util._unPrefix(m);
                        const ids = mandatory.id.split('_');
                        const stageid = ids[0];
                        const roleid = ids[1];
                        const required = util.isTrue(mandatory.value) ? 'yes' : 'no';
                        obligatories.set(mandatory.id, { roleId: roleid, stageId: stageid, required: required});
                    });

                } else {
                    mandatory = util._unPrefix(obj.Obligatories.Obligatory);
                    const ids = mandatory.id.split('_');
                    const stageId = ids[0];
                    const roleId = ids[1];
                    const required = util.isTrue(mandatory.value) ? 'yes' : 'no';
                    obligatories.set(mandatory.id, { roleId: roleId, stageId: stageId, required: required});
                }
                mergedProps.mandatories = obligatories;
            }
            
            //Load States
            self._loadObjectStates(obj, mergedProps);

            // Table Columns
            if (obj.Columns && cType === 'table') {
                mergedProps.Columns = obj.Columns;

                const gridData = [];

                Immutable.List(  util.enforceArrayType( obj.Columns.Column ) ).map((column, key) => {
                    const colInfo = tableService.getColumnInfo(column._type);

                    const newColumn = new GridColumnModel(
                        {
                            'id': listService.cleanId(column._id), 'header': column.Properties._header,
                            'type': column._type, 'name': column._name, 'width': 190,
                            'factoryKey': colInfo.factoryKey , 'displayType': colInfo.name
                        });

                    if (column.Properties._font) {
                        var fonts = column.Properties._font.trim().split(',');
                        if (fonts[0]) {
                            column.Properties.fontFamily = fonts[0];
                        }
                        if (fonts[1]) {
                            column.Properties.fontSize = fonts[1];
                        }
                        if (fonts[2]) {
                            column.Properties.textWeight = fonts[2] + ' !important';
                        }

                        if (fonts[3]) {
                            column.Properties.textStyle = fonts[3] + ' !important';
                        }

                    }
                    //PF-6119 Some flash forms don't have this property
                    if(colInfo.factoryKey === 'fileAttachmentColumn' && !column.Properties._filetypes){
                        column.Properties._filetypes = '0';
                    }

                    if (column.Properties._buttonFont) {
                        var fonts = column.Properties._buttonFont.split(',');
                        if (fonts[0]) {
                            column.Properties.buttonFontFamily = fonts[0];
                        }
                        if (fonts[1]) {
                            column.Properties.buttonFontSize = fonts[1];
                        }
                        if (fonts[2]) {
                            column.Properties.buttonTextWeight = fonts[2] + ' !important';
                        }

                        if (fonts[3]) {
                            column.Properties.buttonTextStyle = fonts[3] + ' !important';
                        }

                    }

                    for (let p in column.Properties) {
                        if (column.Properties.hasOwnProperty(p)) {
                            let val = column.Properties[p];
                            if (val && p.toLowerCase().includes('color')) {
                                column.Properties[p] = util._fixColorFormat(column.Properties[p]);
                            }
                        }
                    }
                      if (column.States) {
                        // build State Map()
                        let statesMap = new Map();
                        let states = {};
                        states.State = [];
                        let state = {};

                        const currentStage = listService.getCurrentStage();
                        const currentRole = listService.getCurrentRole();
                        let stateDisplay = "default";

                        if (Array.isArray(column.States.State) ) {
                          _.forEach(column.States.State, (p) => {
                            state = util._unPrefix(p);
                            //states.State.push(state);

                            const ids = state.id.split('_');
                            let stageid = ids[0];
                            let roleid = ids[1];

                            if(stageid === currentStage && roleid === currentRole){
                                stateDisplay = state.value;
                            }

                            statesMap.set(state.id, { defaultRule: true, roleId: roleid, stageId: stageid, value: state.value });

                          });

                        } else {
                          state = util._unPrefix(column.States.State);
                          //states.State.push(state);

                          const ids = state.id.split('_');
                          let stageid = ids[0];
                          let roleid = ids[1];

                          if(stageid === currentStage && roleid === currentRole){
                                stateDisplay = state.value;
                            }

                          statesMap.set(state.id, { defaultRule: true, roleId: roleid, stageId: stageid, value: state.value });
                        }
                        
                        newColumn.attributes.state = statesMap;
                        newColumn.attributes.stateDisplay = stateDisplay;
                      }

                    if (column.CustomParameters) {
                        let CustomParameters = {};
                        CustomParameters.parameter = [];
                        let param = {};
                        let args = [];

                        if (Array.isArray( column.CustomParameters.parameter )) {
                            //CustomParameters.parameter = column.CustomParameters.parameter;
                            _.forEach(column.CustomParameters.parameter, (p) => {
                                args = [];
                                //param = util._unPrefix(p);
                                param = p;
                                if (param.EXPR) {
                                    self._loadExpression(param.EXPR, args);

                                    param.Expression = {id: param.EXPR._id, type: param.EXPR._type};
                                    param.Expression.arguments = args;
                                }

                                CustomParameters.parameter.push(param);
                            });
                        } else {
                            //CustomParameters.parameter = [ column.CustomParameters.parameter ];
                            param = column.CustomParameters.parameter;
                            if (param.EXPR) {
                                self._loadExpression(param.EXPR, args);

                                param.Expression = {id: param.EXPR._id, type: param.EXPR._type};
                                param.Expression.arguments = args;
                            }

                            CustomParameters.parameter.push(param);
                        }

                        newColumn.attributes.CustomParameters = CustomParameters;
                    }

                    if (column.Obligatories) {
                        let obligatories = new Map();
                        let mandatory = {};
                        if (Array.isArray(column.Obligatories.Obligatory) ) {
                            _.forEach(column.Obligatories.Obligatory, (m) => {
                                mandatory = util._unPrefix(m);
                                const ids = mandatory.id.split('_');
                                const stageid = ids[0];
                                const roleid = ids[1];
                                const required = util.isTrue(mandatory.value) ? 'yes' : 'no';
                                obligatories.set(mandatory.id, { roleId: roleid, stageId: stageid, required: required});
                            });
        
                        } else {
                            mandatory = util._unPrefix(column.Obligatories.Obligatory);
                            const ids = mandatory.id.split('_');
                            const stageId = ids[0];
                            const roleId = ids[1];
                            const required = util.isTrue(mandatory.value) ? 'yes' : 'no';
                            obligatories.set(mandatory.id, { roleId: roleId, stageId: stageId, required: required});
                        }
                        newColumn.attributes.mandatories = obligatories;
                        newColumn.attributes.isMandatory = true;
                    }


                    //----------------  d load any column behaviors
                    if (column.Events && column.Scripts) {

                        // Locally index scripts by scriptId
                        const scriptIndex = {};
                        _.forEach(util.enforceArrayType(column.Scripts.Script), s => scriptIndex[s._id] = s );

                        // Store a behavior for each script / event pair
                        _.forEach(column.Events, (scriptId, pfEventType) => {

                            const behaviorKey = pfEventType.slice(1);
                            const script = scriptIndex[scriptId];

                            const info = {
                                text: script._name,
                                owner: column._name,
                                ownerId:  newColumn.id,
                                ownerCol: newColumn  // behavior on a column knows owning column
                            };

                            this._createBehaviorInstance(scriptId, info, script, pageId, behaviorKey);

                        });
                    }
                    //----------------

                    newColumn.attributes = _.merge(newColumn.attributes, util._unPrefix(column.Properties) );

                    gridData.push(newColumn);
                });

                mergedProps.gridData = gridData;
            }

            const setColumnProperties = (column) => {
                mergedProps.Columns.Column.push( {id: column._id  ,Properties:  util._unPrefix(column.Properties) } );
                let newColumn = {
                    'caption': column.Properties['_caption'],
                    'fieldId': column.Properties['_fieldId']
                };
                
                if (column.EXPR){
                    mergedProps.Columns.Column[mergedProps.Columns.Column.length-1].Properties.expression = util._unPrefix(column.EXPR.EXPR );
                    mergedProps.Columns.Column[mergedProps.Columns.Column.length-1].EXPR = {id:'', type:'', arguments:[]};
                    mergedProps.Columns.Column[mergedProps.Columns.Column.length-1].EXPR.id = column.EXPR._id;
                    mergedProps.Columns.Column[mergedProps.Columns.Column.length-1].EXPR.type = column.EXPR._type;
                    
                    let args = [];
                    this._loadExpression(column.EXPR, args, true);
                    let valueToSet = { id: column.EXPR._id, type: column.EXPR._type }
                    valueToSet.arguments = args;                             
                    mergedProps.Columns.Column[mergedProps.Columns.Column.length-1].EXPR.arguments = args;

                    if(column._id === '0'){
                        switch(cType){
                            case 'gauge':
                                mergedProps.valueFormula = valueToSet;
                            break;
                            case 'value':
                                mergedProps.formulaParameter = valueToSet;
                            break;
                            default:
                                mergedProps.groupFormula = valueToSet;
                            break;
                        }
                    }
                    else if(column._id === '1'){
                        switch(cType){
                            case 'barchart':
                            case 'linechart':
                            case 'piechart':
                                mergedProps.valueFormula = valueToSet;
                            break;
                            case 'crosstab':
                                mergedProps.sideFormula = valueToSet;
                            break;
                        }
                    }
                    else if(column._id === '2'){
                        if(cType === 'crosstab'){
                            mergedProps.typeFormula = valueToSet;
                        }
                    }
                }
                newColumn = _.merge(newColumn, util._unPrefix(column.Properties) );
                return newColumn;
            };
            
            if (this.reportingControls.has(cType)) {
                if (!mergedProps.dataSourceId || mergedProps.dataSourceId.toLowerCase() === 'none'){ //PF-6427 - Report's page is shown outside the designer; Back end was failing to render the HTML properly because this property was not included in the XML.
                    mergedProps.dataSourceId = 'null';
                }

                if (obj.Columns) {
                    mergedProps.Columns = {};
                    mergedProps.Columns.Column = [];
                    const gridData = [];
                    let colId = 0;
                    if ( Array.isArray( obj.Columns.Column )) {
                        _.forEach(obj.Columns.Column, (column) => {
                            column._id = colId.toString();
                            colId++;
                            gridData.push(setColumnProperties(column));
                        });
                    } else {
                        if (obj.Columns.Column) {
                            gridData.push(setColumnProperties(obj.Columns.Column));
                        }
                    }
                    mergedProps.gridData = gridData;
                }
                if (obj.Property) {
                    mergedProps.Property = obj.Property;
                }

                // PF-5737 if it's a datagrid/datalist validate if allow export is true to remove hidden class for the export button
                if ((factoryKey === 'control_data_grid' || factoryKey === "control_data_list") && mergedProps.allowExport === 'true') {
                    mergedProps.allowExportHide = '';
                }
            }

            model.set(mergedProps, SILENT );

            if(factoryKey === 'control_table'){
                tableService.buildSelectList(view.model);
            }

            //Change the id inside of selectFields with the correct id saved of the object
            if (factoryKey === 'control_list' || factoryKey === 'control_drop_down'){
               if(view.model.attributes.selectFields){
                  let selectFields = view.model.get('selectFields');
                  let id = view.model.get('id');
                  _.forEach(selectFields, (f) => {
                        if(f.text === 'Value'){
                            f.id = id + '$v';
                        }else{
                            f.id = id;
                        }
                   });
                   view.model.set('selectFields', selectFields, SILENT);
               }
            }

            if (factoryKey === 'control_list' || factoryKey === 'control_drop_down'){
                if (mergedProps.Property){
                    let prop = mergedProps.Property;
                    let values = [];
                    let captions = [];
                    // PF-1289
                    let selectedIndex = cProps.selectedIndex;

                    for (let p in prop){
                        if (prop[p]._id === 'values') {
                            values = prop[p].Item;
                        } else if (prop[p]._id === 'captions') {
                            captions = prop[p].Item;
                        } else {
                            selectedIndex = prop[p].selectedIndex;
                        }
                    }

                    //PF-8364
                    if (!selectedIndex || (captions && selectedIndex >= captions.length) || (selectedIndex && !captions)) {
                        selectedIndex = -1;
                        listService.isPartialSave = false;
                    }

                    let gridData = [];
                    if(captions){
                        if (Array.isArray(captions)) {
                            for (let i = 0; i < captions.length; i++) {
                                let newRow = {
                                    'caption': captions[i]._value,
                                    'value': values[i]._value,
                                    // PF_1289:
                                    'selected': selectedIndex === String(i) ? 'selected' : ''
                                };
                                gridData.push(newRow);
                            }
                        } else {
                            gridData.push({
                                'caption': captions._value,
                                'value': values._value,
                                'selected': selectedIndex === '0' ? 'selected' : ''
                            });
                        }
                    }
                    model.set('gridData', gridData, SILENT);
                    model.set('selectedIndex', selectedIndex, SILENT);
                }
            }

            if (factoryKey === 'control_ranking'){
                if (mergedProps.Property){
                    let prop = mergedProps.Property;
                    let ranks = [];
                    let captions = [];
                    // PF-1289
                    let selectedIndex = cProps.selectedIndex;

                    for (let p in prop){
                        if (prop[p]._id === 'ranks') {
                            ranks = prop[p].Item;
                        } else if (prop[p]._id === 'captions') {
                            captions = prop[p].Item;
                        } else {
                            selectedIndex = prop[p].selectedIndex;
                        }
                    }

                    if (!selectedIndex) {
                        selectedIndex = -1;
                    }

                    let gridData = [];
                    if(captions){
                        if (Array.isArray(captions)) {
                            for (let i = 0; i < captions.length; i++) {
                                let newRow = {
                                    'item': captions[i]._value,
                                    'rank': ranks[i]._value
                                };
                                gridData.push(newRow);
                            }
                        } else {
                            gridData.push({
                                'item': captions._value,
                                'rank': ranks._value
                            });
                        }
                    }
                    model.set('gridData', gridData,{silent:true});
                    model.set('selectedIndex', selectedIndex,{silent:true});
                }
            }



            view.pageId = pageId;

            // If object is a group, then IF it has  child controls. Store them.
            if (view && self.groupSet.has( cType )) {

                // Append the group's children to the group View.childList, set parent id,
                if ( obj && obj.Objects && obj.Objects.Object  ) {
                    const group = view;

                    group.model.attributes.childList = []; // make sure it starts empty.
                    Immutable.List( $.makeArray( obj.Objects.Object )).map(cobj => {


                        sequenceService.tabIndexParentId = group.id;
                        // ====> Recurse on group, radiobutton group, or tickbox group <====
                        const cview = self._recursiveObjectLoader( cobj, pageId );
                        sequenceService.tabIndexParentId = pageId;

                        // Connect parent-child relationship
                        if(cview && cview.model){
                            group.model.get('childList').push( cview.model);
                            cview.groupId = group.id;
                        }

                    });


                /*} else if (obj && obj.Object  ) {
                    //console.log(`GROUP WITH NO (or one?)  detected children 1 `, obj );
                } else {
                    //console.log(`GROUP WITH NO detected children 2 `, obj );*/
                }

                // Load the group object that sent us into this scope
                listService.addObject(view.id, view, SILENT);
                this._createBehaviorInstances( obj, view.id, view.pageId );

            } else {

                // Load simple object
                listService.addObject(view.id, view, SILENT);

                // Load all `scripts` for any events of this control
                this._createBehaviorInstances( obj, view.id, view.pageId );
            }

        }

        if(view && view.model && view.model !== undefined){
            view.model.resetLastState();
            //PF-6630 For print and page button the related pages should be loaded in case the page is deleted.
            view.model.trigger("loadRelatedPages");
        }

        return view; // used by group recursion
    }



    //======================================================================
    // Load the objects. These are the meat of the layout. They have
    // RECURSIVE scripts, controls, events ...
    // + Pages
    //   + Page 1
    //     + _id=pageid, _type='group, Properties, Objects, Events,
    //            (recurse through Objects -- same elements possible)
    //   + Page 2
    //     + _id=pageid, _type='group, Properties, Objects, Events,
    //            (recurse through Objects -- same elements possible)
    //  ...
    //======================================================================
    _loadObjects( obj ){
        
        const pageFn = page => {
            // Page object def: outermost should be a page with type 'group' with its _id matching a page id,

            if (!page || !page._id || page._type !== 'group'){
                throw(`PANIC. expected inbound XML page. Got `, page);
            }

            const
                //pageId = listService.getPageByOther( p => p.model.get('altId') === page._id ).id,
                pageId = listService.cleanId(page._id),
                pObjects = page.objects ? page.objects : page.Objects; //  (recursive)
            
            //Save original Page items
            let pageView = listService.pageList.get(listService.cleanId(page._id));
            if (pObjects && pageView){
                pageView.model.set('parsedItem', _.cloneDeep(pObjects), constants.MODEL_SILENT);
            }

            const pProps = util._unPrefix(page.Properties);
            for (let p in pProps) {
                if (pProps.hasOwnProperty(p)) {
                    let val = pProps[p];
                    if (val && p.toLowerCase().includes('color')) {
                        pProps[p] = util._fixColorFormat(pProps[p]);
                    }
                }
            }

            //Load States
            self._loadObjectStates(page, pProps);

            const _pg = listService.getPage( pageId );
            
            if (!_pg.model.get('name') && page._name){ //PF-5989 - Page names missing (Old form)
                pProps['name'] = page._name;
                pProps['pageTitle'] = page._name;
            }
            
            _pg.model.set(pProps, SILENT);

            listService.currentPageId = pageId;

            self._createBehaviorInstances( page, pageId, pageId );

            //sequenceService.resetTabIndex(1);
            sequenceService.tabIndexParentId = pageId;
            // If non-empty page:
            if ( pObjects && pObjects.Object ) {
                if (Array.isArray( pObjects.Object )) {
                    // Drill-down of controls for this page. i.e. We're in a page: load it's objects; recurse on groups
                    Immutable.List( pObjects.Object ).map(obj =>
                        self._recursiveObjectLoader(obj, pageId) // ref singleton, avoids "this" Hell
                    );
                } else {
                    self._recursiveObjectLoader(pObjects.Object, pageId);
                }
            }
        };

        // Assuming a page list loaded by now: for each object, load its objects.
        _.forEach(  util.enforceArrayType(obj.Object), page => pageFn( page ));

    }

    //PF-6369 - Old Forms: Error on submit if form contains a notify command with Attachment Print enabled
    _validateAndFixNotificationsProperties(notificationProperties){
        let existingInstanceAttachment = notificationProperties['existingInstanceAttachment'];
        let existingInstanceAttachmentSelected = notificationProperties['existingInstanceAttachmentSelected'];

        if (typeof existingInstanceAttachment !== 'undefined' && listService.getPage(existingInstanceAttachment)){ //Validating that the value of this property is not a page (although it can be page-caption  or page-value)
            notificationProperties['existingInstanceAttachment'] = '';
        }

        if (typeof existingInstanceAttachmentSelected !== 'undefined' && listService.getPage(existingInstanceAttachmentSelected)){ //Validating that the value of this property is not a page (although it can be page-caption  or page-value)
            notificationProperties['existingInstanceAttachmentSelected'] = '';
        }
    }


    //PF-8756 Remove duplicated notifications Ids after pasting notify command.
    _validateAndFixNotificationsDuplicatedId(notification){

        if(this.loadedNotifications.includes(notification.notificationId)){
            notification.notificationId = sequenceService.nextDomId();            
        }   
        
        this.loadedNotifications.push(notification.notificationId);
    }

    //PF-6628 Error on submit because a form had an attachment control in the print attachments, only pages should be allowed
    _validateAndFixPrintAttachments(attributes, props, pages) {

        const checkPage = (pageId) => {
            let isPage = false;
            _.each(pages, (page) => {
                if (page._id === pageId) {
                    isPage = true;
                }
            });

            return isPage;
        };

        const validateAttachments = (printAttachments, shouldBePage) => {
            const objects = printAttachments.split("|");
            let validIds = [];

            _.forEach(objects, (obj) => {
                let id = obj.split(",")[0];

                if (shouldBePage) {
                    if (checkPage(id)) {
                        validIds.push(obj);
                    }
                }
                else {
                    if (!checkPage(id)) {
                        validIds.push(obj);
                    }
                }

            });
            return validIds.join("|");
        };


        _.each(props, (prop) => {


            const attachments = attributes[prop.name];
            if (attachments && attachments !== "") {
                attributes[prop.name] = validateAttachments(attachments, prop.acceptPages);
            }
        });

    }

    // convert the JSON object structure from PF into the object our Formula window uses
    _convertNotifications( notifications ) {
        let cvNotifications = [];
        let args;
        let self = this;

        _.forEach(notifications, (notification) => {
            let cvNotification = {};
            cvNotification.notificationId = notification._id;

            const props = util._unPrefix(notification.Properties);
            this._validateAndFixNotificationsProperties(props);

            const attachmentProps = [{name: 'printAttachment',acceptPages: true}, 
                {name: 'printAttachmentSelected', acceptPages: true},
                {name: 'insertAttachment', acceptPages: false},
                {name: 'insertAttachmentSelected', acceptPages: false}];
             
            this._validateAndFixPrintAttachments(props, attachmentProps, util.enforceArrayType(self.Pages));

            this._validateAndFixNotificationsDuplicatedId(cvNotification);

            for (var p in props) {
                if (props.hasOwnProperty(p) && (props[p] !== undefined) && p !== '_id') {
                    let val = props[p];
                    const key = `${p}`;
                    cvNotification[key] = val;
                }
            }

            if(notification.Condition && notification.Condition.EXPR){
                args = [];
                self._loadExpression(notification.Condition.EXPR, args);
                cvNotification.cancelCondition = 
                {
                    id: notification.Condition.EXPR._id || sequenceService.nextDomId(), 
                    type: notification.Condition.EXPR._type || 'scriptingCondition'
                };

                cvNotification.cancelCondition.arguments = args;
            }

            /*Let's check if there missing values*/
            defaultNotifySchema.addMissingProps(cvNotification);


            if (cvNotification.activationType ==='5' && notification.ActivationDateExpression) {
                args = [];                                
                this._loadExpression(notification.ActivationDateExpression.EXPR, args);
                cvNotification.activationDateExpression = {arguments: args, id: notification.ActivationDateExpression.EXPR._id};
                if (!notification.ActivationDateExpression.EXPR._id){ //PF-5537 - Connections are failing and submitting the form is not working
                    cvNotification.activationDateExpression.id = sequenceService.nextDomId(); //This kind of expressions were being stored in XML without the id attribute
                    cvNotification.activationDateExpression.type = 'scriptingCondition';
                }
            }
            
            if (cvNotification.activationType !=='5' && notification.ActivationDateExpression) {
                cvNotification.activationDateExpression = "";
            }

            cvNotifications.push(cvNotification);
        });

        return cvNotifications;
    }

    _createBehaviorInstance(scriptId, info, script, pageId, behaviorKey) {

        let newScriptId = listService.cleanId(scriptId);

        if (script) {

            //PF-6110 Check if the behavior instance already exists with that id to avoid problems with duplicated flash ids in the xml
            const instanceExists = listService.getBehaviorInstance(newScriptId);
            if (instanceExists) {
                newScriptId = sequenceService.nextCleanId();
            }

            let name= script._name && script._name !==""  ? script._name : info.text;
            const behaviorInstance = new BehaviorInstanceModel({
                id: newScriptId,
                behaviorKey: behaviorKey,
                pageId: pageId,
                text: name,
                open: false,
                owner: info.owner,
                ownerId: info.ownerId,
                ownerCol: info.ownerCol, // Only defined for table column behaviors
                name: name,
                width: script.Properties._width,
                height: script.Properties._height,
                parsedItem: JSON.parse(JSON.stringify(script))
            });
            listService.addBehaviorInstance(behaviorInstance, true);
        }


        // Commands, Properties, optional Parameters, optional CustomParameters

        // commandIndex used to look up a pair of commands for linking into a connection
        const commandIndex = {};        
        if (script && script.Commands && script.Commands.Command) {

            _.forEach(util.enforceArrayType(script.Commands.Command), v => {

                // Note: v is XML converted to JavaObject. Its id at this point is _id from id attribute
                // We'll track the connection linkage by those IDs.
                commandIndex[v._id] = v;

                //**PF-5733
                if (v._type === "transaction") {
                    const getConnectionType = (type) => {
                        const values = {
                            'start': () => {
                                return '0';
                            },
                            'rollback': () => {
                                return '1';
                            },
                            'commit': () => {
                                return '2';
                            }
                        };

                        return values[type];
                    }
                    if (!v.Properties._connectionType) {
                        v.Properties.connectionType = v.Properties._type;
                    } else {
                       const fn = getConnectionType(v.Properties._connectionType);
                       if (fn !== undefined) {
                           v.Properties.connectionType = fn();
                       }
                    }

                    v.Properties._type = v._type;
                }

                //PF-5733 **/
                const
                    cProps = util._unPrefix(v.Properties),
                    pos = {left: util.extractNum(v.Properties._x), top: util.extractNum(v.Properties._y)},
                    factoryParams = factoryService.getBehaviorsFactoryByType(v._type),
                    factoryKey = factoryParams.factoryKey,
                    cmdView = factoryParams.factory.createView(factoryKey, pos);

                this._validateAndFixCommandProperties(factoryKey, cProps);

                const mergedProps = _.merge(cProps, {'id': listService.cleanId(v._id)});

                // PF-4494
                // Width and height's behaviors in the xml are different of the default values, we need to keep the default values
                mergedProps.width = v._type === "comment" ? v.Properties._width : factoryParams.width;
                mergedProps.height = v._type === "comment" ? v.Properties._height  : factoryParams.height;


                cmdView.model.set(mergedProps, SILENT);

                //PF_6479 Added this extra validation in case there are more than one or empty Expression in the XML, this was 
                //probably caused by a bug in an older version of flash.
                const checkValidExpressions = (EXPR) => {
                    return _.filter(EXPR, (expression) => {
                        return expression.EXPR && expression._id;
                    });
                };

                // Handle Expression, might be able to make this more streamlined, just getting it going now.
                // PF-2295 Handling if notifications data come from Notifications property or from Notification direct child.
                const notificationsToLoad = [];
                if (v && v.Notifications && v.Notifications.Notification) {
                    // PF-4862 D.R.Y.
                    _.forEach(util.enforceArrayType(v.Notifications.Notification), notification => {
                        const role = listService.getWorkflowRole(notification.Properties._roleId);
                        notification.Properties._role =  role ? role.name : 'Unspecified';
                        notificationsToLoad.push(notification);
                    });

                }

                if (notificationsToLoad.length) {
                    const notifications = this._convertNotifications(notificationsToLoad);
                    cmdView.model.set('notifications', notifications, SILENT);
                }

                if (v.Parameters) {
                    const params = {};
                    params.Parameter = [];
                    let param = {};

                    let args = [];

                    if (Array.isArray(v.Parameters.Parameter)) {
                        _.forEach(v.Parameters.Parameter, (p) => {
                            args = [];
                            param = util._unPrefix(p);
                            if (param.EXPR) {
                                self._loadExpression(param.EXPR, args);

                                param.Expression = {id: param.EXPR._id, type: param.EXPR._type};
                                param.Expression.arguments = args;
                            }

                            params.Parameter.push(param);
                        });

                    } else {
                        param = util._unPrefix(v.Parameters.Parameter);
                        if (param.EXPR) {
                            self._loadExpression(param.EXPR, args);

                            param.Expression = {id: param.EXPR._id, type: param.EXPR._type};
                            param.Expression.arguments = args;
                        }
                        if (typeof param.id !== 'undefined'){ //PF-5791; There shouldn't be parameters without id attribute because it is expected in back-end
                            params.Parameter.push(param);
                        }
                    }
                    //Set FormulaParameter to all the behaviors which contains formula
                    const _behaviors= new Immutable.Set(['command_simple_branch']);
                    if( _behaviors.contains(cmdView.model.get('factoryKey')) ){
                        cmdView.model.set('formulaParameter', params.Parameter[0].Expression, SILENT);
                        this._checkIfBooleanConnectorsAreValid(cmdView, script, v._id);
                    }
                    cmdView.model.set('Parameters', params, SILENT);

                }

                if (v.Request) {
                    let Request = {};
                    Request.Send = {};
                    Request.Receive = {};
                    Request.Send.parameter = [];

                    let param = {};
                    let args = [];
                    let sendParameter = [];
                    let receiveParameter = [];

                    if (Array.isArray(v.Request.Send.parameter)) {
                        //Request.Send.parameter = v.Request.Send.parameter;
                        _.forEach(v.Request.Send.parameter, (p) => {
                            args = [];
                            param = p;

                            if (param.EXPR) {

                                if (Array.isArray(param.EXPR)){
                                    param.EXPR = checkValidExpressions(param.EXPR)[0];
                                }
                                
                                self._loadExpression(param.EXPR, args);

                                param.Expression = {id: param.EXPR._id, type: param.EXPR._type};
                                param.Expression.arguments = args;
                            }

                            Request.Send.parameter.push(param);

                        });


                    } else {
                        //Request.Send.parameter = [v.Request.Send.parameter];

                        param = v.Request.Send.parameter;

                        if (param){
                            if (param.EXPR) {
                                if (Array.isArray(param.EXPR)){
                                    param.EXPR = checkValidExpressions(param.EXPR)[0];
                                }
                                
                                self._loadExpression(param.EXPR, args);

                                param.Expression = {id: param.EXPR._id, type: param.EXPR._type};
                                param.Expression.arguments = args;
                            }
                            
                            Request.Send.parameter.push(param);
                        }
                    }

                    if (Array.isArray(v.Request.Receive.parameter)) {
                        Request.Receive.parameter = v.Request.Receive.parameter;
                    } else {
                        Request.Receive.parameter = [v.Request.Receive.parameter];
                    }


                    cmdView.model.set('Request', Request, SILENT);

                }

                if (v.CustomParameters) {
                    let CustomParameters = {};
                    CustomParameters.parameter = [];
                    //let params = {};
                    //params.Parameter = [];
                    let param = {};
                    let args = [];


                    if (Array.isArray(v.CustomParameters.parameter)) {
                        //CustomParameters.parameter = v.CustomParameters.parameter;
                        _.forEach(v.CustomParameters.parameter, (p) => {
                            args = [];
                            //param = util._unPrefix(p);
                            param = p;
                            if (param.EXPR) {    
                                if (Array.isArray(param.EXPR)){
                                    param.EXPR = checkValidExpressions(param.EXPR)[0];
                                }
                                
                                self._loadExpression(param.EXPR, args);

                                param.Expression = {id: param.EXPR._id, type: param.EXPR._type};
                                param.Expression.arguments = args;
                            }

                            CustomParameters.parameter.push(param);
                        });
                    } else {
                        //CustomParameters.parameter = [ v.CustomParameters.parameter ];
                        //param = util._unPrefix(v.CustomParameters.parameter);
                        param = v.CustomParameters.parameter;
                        if (param.EXPR) {
                            if (Array.isArray(param.EXPR)){
                                param.EXPR = checkValidExpressions(param.EXPR)[0];
                            }
                            
                            self._loadExpression(param.EXPR, args);

                            param.Expression = {id: param.EXPR._id, type: param.EXPR._type};
                            param.Expression.arguments = args;
                        }

                        CustomParameters.parameter.push(param);

                    }

                    cmdView.model.set('CustomParameters', CustomParameters, SILENT);
                }

                cmdView.model.trigger('loadRelatedFields');
                listService.addBehaviorObject(cmdView.model.get('id'), cmdView);

            });

        }

        // Connectors
        const connIndex = {};

        // Example of a curved connector XML coming from the wire::
        //--------------------------------------------------------------------------------------------------------------
        // <Connector id="VRgkOQAAdm8AADnkAACzDdY5Ftc=" type="scriptconnector">
        //     <Properties textBoxHeight="4" textBoxWidth="100" text="" ctrlPoint1y="125" ctrlPoint2y="105"
        //          targetShape="kjklZQAAMWMAAOLvAAAXYMYbO/Q=" lineType="bezier" sourceShape="5X46FwAAKukAAKXDAABexZ/Jwfo="
        //          sourcePoint="1" autosummary="true" ctrlPoint1x="141" ctrlPoint2x="161" targetPoint="3" />
        // </Connector>
        //--------------------------------------------------------------------------------------------------------------

        // Iterate across the connections that came from XML
        if (script && script.Connectors && script.Connectors.Connector) {
            _.forEach(util.enforceArrayType(script.Connectors.Connector), (connector, k) => {
                const cleanId = listService.cleanId(connector._id);
                connector.id = cleanId;
                connIndex[cleanId] = connector;

                const cn = connector.Properties || connector;


                // Record original points and record dot / connection-point, for each end.
                // const connection = new Object({
                //     id: cleanId,
                //     scriptId: newScriptId,
                //     initCoords: {left: 0, top: 0},
                //     name: 'My Connection',
                //     srcDot: Number(cn._sourcePoint) + 1,  // dotnumber + 1 is connection index
                //     destDot: Number(cn._targetPoint) + 1,  // dotnumber + 1 is connection index
                //     srcCommand: listService.getBehaviorObject(cn._sourceShape),
                //     destCommand: listService.getBehaviorObject(cn._targetShape)
                // });

                const
                    src     = listService.getBehaviorObject( listService.cleanId( cn._sourceShape )),
                    dest    = listService.getBehaviorObject( listService.cleanId( cn._targetShape )),
                    srcDot  = Number(cn._sourcePoint) ,
                    destDot = Number(cn._targetPoint) ,
                    opts = { id: cleanId, scriptId: newScriptId };

                const lineModel = new LineModel( { initCoords: undefined, name: 'My Connection', srcDot: srcDot, destDot: destDot });
                const connectionVO = new ConnectionVO( src, dest, srcDot, destDot, opts);
                lineModel.attributes.id =  connectionVO.id;
                lineModel.attributes._id =  connector._id; //PF-6374 add the original id in case it's a form from flash
                lineModel.attributes.srcWidgetModel = src.model;
                lineModel.attributes.destWidgetModel = dest.model;
                lineModel.attributes.text = cn._text;
                lineModel.attributes.textBoxWidth = cn._textBoxWidth;
                lineModel.attributes.autosummary = cn._autosummary;

                // PF-2345 Preserve curved or staight line inbound
                FormLoadService.loadPathLineProps(lineModel, cn);
                

                if (src.model.attributes.factoryKey === 'command_simple_branch') {

                    
                    //The nextTrue property is used in old forms
                    const trueConnector = src.model.attributes.trueConnector || src.model.attributes.nextTrue;

                    //This validation is used for old forms where the trueConnector has the targetShape reference instead of the id of the connection.
                    if(trueConnector === connector.Properties._targetShape){
                        src.model.attributes.trueConnector = connector._id;
                    }

                    if (src.model.attributes.trueConnector === connector._id) {
                        lineModel.attributes.branchBooleanDisplay = 'true';
                    } else {
                        lineModel.attributes.branchBooleanDisplay = 'false';
                    }
                }

                if (connector.Parameters) {
                    let params = {};
                    params.Parameter = [];
                    let param = {};

                    let args = [];

                    if (Array.isArray(connector.Parameters.Parameter)) {
                        _.forEach(connector.Parameters.Parameter, (p) => {
                            args = [];
                            param = util._unPrefix(p);
                            if (param.EXPR) {
                                self._loadExpression(param.EXPR, args);

                                param.Expression = {id: param.EXPR._id, type: param.EXPR._type};
                                param.Expression.arguments = args;
                            }

                            params.Parameter.push(param);
                        });

                    } else {
                        param = util._unPrefix(connector.Parameters.Parameter);
                        if (param.EXPR) {
                            self._loadExpression(param.EXPR, args);

                            param.Expression = {id: param.EXPR._id, type: param.EXPR._type};
                            param.Expression.arguments = args;
                        }

                        params.Parameter.push(param);
                    }
                    lineModel.set('Parameters', params, SILENT);
                }

                connectionVO.model = lineModel;

                // PF-2345 pull copies of line parameters up to connectionVO body
                FormLoadService.reflectModelToConnectionVO(connectionVO);

                dest.model.trigger("loadRelatedFields", lineModel.get("Parameters"));
                listService.addBehaviorConnection(connectionVO);
            });
        }

    }

    _checkIfConnectorExists(connectors, connectorID){

        let conns = [];

        if(Array.isArray(connectors)){
            conns = connectors.filter((connector)=>{
                return connector._id === connectorID; 
            });
        }
        else{
            if(connectors._id === connectorID){
                conns.push(connectors);
            }
        }

        return conns;
    }

    //PF-6628 A bug in copy paste caused that if a simple branch was copied and pasted the connectors true/false ids would also be copied and 
    //it was causing unexpected behaviors and loops. A connector can only have one source and one target.
    _checkIfCommandIsConnectorSource(command, connectorID){        
        return command && command.Properties._sourceShape === connectorID;
    }

    _checkIfBooleanConnectorsAreValid(cmdView, script, commandId){        
        let trueConnectorFound = false, falseConnectorFound = false;
        let trueConnector = cmdView.model.get('trueConnector');
        let falseConnector = cmdView.model.get('falseConnector');
        if (script.Connectors && script.Connectors.Connector) {
            let connectors = util.enforceArrayType(script.Connectors.Connector);
            trueConnectorFound = !trueConnector;
            falseConnectorFound = !falseConnector;

            //PF-6376 Check if connectors really exists, if they don't clean the value to avoid lost references
            if (trueConnector !== '' && this._checkIfConnectorExists(script.Connectors.Connector, trueConnector).length === 0) {
                cmdView.model.set('trueConnector', '', constants.MODEL_SILENT);
            }

            //PF-6628 For false connectors also check that the command Id corresponds to the connector source
            let falseConnectorExist = this._checkIfConnectorExists(script.Connectors.Connector, falseConnector);
            let correctFalseConnector = falseConnectorExist.length && this._checkIfCommandIsConnectorSource(falseConnectorExist[0], commandId);

            if (falseConnector !== '' && (falseConnectorExist.length === 0 || !correctFalseConnector)) {
                cmdView.model.set('falseConnector', '', constants.MODEL_SILENT);
            }

            $.each(connectors, (idx, item) => {
                if (!trueConnectorFound && item._id === trueConnector) {
                    trueConnectorFound = true;
                } else if (!falseConnectorFound && item._id === falseConnector) {
                    falseConnectorFound = true;
                }

                if (trueConnectorFound && falseConnectorFound) {
                    return;
                }
            });

            if (trueConnectorFound && !falseConnectorFound) { //In this case only the false connector is not mapped correctly
                $.each(connectors, (idx, item) => {
                    if (item.Properties._sourceShape === commandId && item._id !== trueConnector) {
                        cmdView.model.set('falseConnector', item._id, constants.MODEL_SILENT);
                        return;
                    }
                });
            } else if (!trueConnectorFound && falseConnectorFound) { //In this case only the true connector is not mapped correctly
                $.each(connectors, (idx, item) => {
                    if (item.Properties._sourceShape === commandId && item._id !== falseConnector) {
                        cmdView.model.set('trueConnector', item._id, constants.MODEL_SILENT);
                        return;
                    }
                });
            }
        }
    }

    //======================================================================
    // Look for known Command properties that can contain invalid values and fix them
    //======================================================================
    _validateAndFixCommandProperties(factoryKey, cProps){
        if (factoryKey.toLowerCase() === 'command_exit'){
            if (!cProps['cancelEvent']){
                cProps['cancelEvent'] = 'false'; //default value
            }
        }
    }

    //======================================================================
    // Create behaviorinstance BB models from form load XML.
    // Here, "object", "objectId", and "obj" are about a control.
    //======================================================================
    _createBehaviorInstances(obj, objId, pageId) {
        if (obj.Events) {

            //---------------- local helper fn -----------------------
            function _createBehaviorInfo(objectId, behaviorKey) {
                const returnObj = {
                    text: '',
                    owner: ''
                };

                const obj = listService.getObject(objectId) || listService.getPage(objectId) || listService.currentForm;

                if (obj) {
                    const type = obj.model.get('factoryKey');

                    const found = objectBehaviorMap.getBehaviors(type)
                        .filter(behavior => (behavior.behaviorKey === behaviorKey));

                    if (found.length) {
                        returnObj.text = found[0].text;
                    }

                    returnObj.owner = obj.model.get('name');
                    returnObj.ownerId = obj.model.get('id');

                    if (type === 'layout_frame' || type === 'reports_frame') {
                        returnObj.owner = 'Form';
                        returnObj.ownerId = 'Form';
                    }

                }

                return returnObj;
            }

            //---------------- End local helper fn -------------------

            // Index Script objects by their raw event XML IDs.
            // Associates PF event types to scripts
            const scriptIndex = {};

            if (Array.isArray( obj.Scripts.Script )) {
                _.forEach(obj.Scripts.Script, scriptItem => {
                    scriptIndex[ scriptItem._id ] = scriptItem;
                });
            } else {
                scriptIndex[ obj.Scripts.Script._id ] = obj.Scripts.Script;

            }


            // scriptId, aka behavior ID
            _.forEach(obj.Events, (scriptId, pfEventType) => {

                const cScriptId = scriptId;

                const
                    //objId = listService.cleanId( obj._id ),
                    behaviorKey = pfEventType.slice(1),
                    info = _createBehaviorInfo(objId, behaviorKey),
                    script = scriptIndex[ scriptId ];

                //If the script doesn't contain any command then the script is empty and shouldn't be created    
                if(script && script.Commands){
                    this._createBehaviorInstance(scriptId, info, script, pageId, behaviorKey);
                }               



            });

        }
    }

    _createBehaviorInstanceForWorkflow(obj, objId) {
        if (obj.Script) {
            const
                behaviorKey = 'workflow',
                info = {owner: 'Workflow', ownerId: objId},
                script = obj.Script;

            this._createBehaviorInstance(obj.Script._id, info, script, '', behaviorKey);



        }
    }

    //======================================================================
    // Load the assets
    //======================================================================
    _loadAssets(obj ){

        const createAsset = (item, k) => {
            const assetItem = util._unPrefix(item);
            assetCollection.add(assetItem);

        };

        assetCollection.reset();
        if ( Array.isArray( obj.Asset )) {
            Immutable.List(obj.Asset).map( v => createAsset(v) );
        } else {
            // obj.Asset not an array; is a solid Asset item
            createAsset( obj.Asset, {} );
        }
    }

    _loadMultilanguage( obj ) {

        const decodeHTMLEntities = (encodedStr) => {
            const txt = document.createElement("textarea");
            txt.innerHTML = encodedStr;
            return txt.value;
        }
        const json = zLib.decompressForm( obj._json );
        const multilang = JSON.parse(decodeHTMLEntities(json));
        listService.multilanguage = multilang;        
    }

    _loadAdvancedCSS(obj) {
            
        try{
            const decodeHTMLEntities = (encodedStr) => {
                const txt = document.createElement("textarea");
                txt.innerHTML = encodedStr;
                return txt.value;
            }
            const CSSText = zLib.decompressForm( obj._css );
            const editor = decodeHTMLEntities(CSSText);
            listService.advancedCSS = editor;   
            const advCSSEnabled = util.isTrue( obj._enabled );
            listService.isAdvancedCSSEnabled = advCSSEnabled;    
            
        }catch(err){
            console.error("Error loading advanced CSS.");
        }
    }    

    _loadDataSources( obj ) {

        let DataSource = {};

        const loadFields = (DataSource, FieldArray) => {
            _.forEach(FieldArray, (field) => {
                DataSource.Fields.Field.push(util._unPrefix( field ));
            })
        };

        const loadDataSource = (ds) => {
            DataSource = util._unPrefix( ds );
            DataSource.Fields = {};
            DataSource.Fields.Field = [];
            DataSource.formulaParameter = {};

            if ( Array.isArray( ds.Fields.Field )) {
                loadFields( DataSource,  ds.Fields.Field);
            } else {
                DataSource.Fields.Field.push(util._unPrefix( ds.Fields.Field ));
            }

            DataSource.id = listService.cleanId(DataSource.id);
            
            if (DataSource.Filter) {
                let args = DataSource.formulaParameter;
                if ( !(args instanceof Array) && util.isEmptyObject(args)) {
                    args = [];
                }
                self._loadExpression(DataSource.Filter.EXPR, args, true)
                DataSource.formulaParameter = {id: DataSource.Filter.EXPR._id, type: DataSource.Filter.EXPR._type};
                DataSource.formulaParameter.arguments = args;
                
            }
            listService.addDataSource(DataSource);
        };

        if ( Array.isArray( obj.DataSource )) {
            _.forEach(obj.DataSource, (ds) =>  {
                loadDataSource(ds);
            });

        } else {
            loadDataSource(obj.DataSource);
        }
    }

    _loadFormEvents( obj ) {

        const formObj = {
            Events: obj.get('Events'),
            Scripts: obj.get('Scripts')
        };

        self._createBehaviorInstances(formObj, '', '');

    }

    _loadReportingMetaData( obj ) {
        let metaData = new reportingMetaData();
        
        if ( Array.isArray( obj.Object )) {
            _.forEach(obj.Object, (object) =>  {
                metaData = new reportingMetaData({
                    id:  listService.cleanId(object._id),
                    name: object._name,
                    dataSource: listService.cleanId(object._dataSource),
                    isAggregate: object._isAggregate,
                    ignoreNull: object._ignoreNull
                });

                if (object.Columns) {
                    const cols = self._loadMetaDataObjectColumns(object.Columns);
                    metaData.Columns = cols;
                }

                listService.addReportingMetaData(metaData);
            });

        } else {

            metaData = new reportingMetaData({
                id:  listService.cleanId(obj.Object._id),
                name: obj.Object._name,
                dataSource: listService.cleanId(obj.Object._dataSource),
                isAggregate: obj.Object._isAggregate,
                ignoreNull: obj.Object._ignoreNull
            });

            if (obj.Object.Columns) {
                const cols = self._loadMetaDataObjectColumns(obj.Object.Columns);
                metaData.Columns = cols;
            } 

            listService.addReportingMetaData(metaData);
        }
    }

    _loadMetaDataObjectColumns( Columns ) {
        const cols = [];

        if ( Array.isArray( Columns.Column )) {
            _.forEach(Columns.Column, (col) =>  {
                const column = {
                    id: col._id,
                    aggregation: col._aggregation,
                    sortType: col._sortType,
                    sortOrder: col._sortOrder,
                    visible: col._visible,
                    Expression: {}
                };
                if(col.EXPR._id && col.EXPR._type){
                    column.Expression.id = col.EXPR._id;
                    column.Expression.type = col.EXPR._type;
                }                
                let args = [];
                this._loadExpression(col.EXPR, args, true);
                
                column.Expression.Argument = args;

                cols.push(column);
            });
        } else {
            const column = {
                id: Columns.Column._id,
                aggregation: Columns.Column._aggregation,
                sortType: Columns.Column._sortType,
                sortOrder: Columns.Column._sortOrder,
                visible: Columns.Column._visible,
                Expression: {}
            };
            
            if(Columns.Column.EXPR._id && Columns.Column.EXPR._type){
                column.Expression.id = Columns.Column.EXPR._id;
                column.Expression.type = Columns.Column.EXPR._type;
            }   

            let args = [];
            this._loadExpression(Columns.Column.EXPR, args);
            
            column.Expression.Argument = args;

            cols.push(column);
        }

        return cols;
    }    

    _loadObjectStates(obj, props){
        if (obj.States) {
            // build State Map()
            let statesMap = new Map();
            let states = {};
            states.State = [];
            let state = {};
            if (Array.isArray(obj.States.State) ) {
                _.forEach(obj.States.State, (p) => {
                    state = util._unPrefix(p);

                    const ids = state.id.split('_');
                    let stageid = ids[0];
                    let roleid = ids[1];

                    statesMap.set(state.id, { defaultRule: true, roleId: roleid, stageId: stageid, value: state.value });
                });

            } else {
                state = util._unPrefix(obj.States.State);

                const ids = state.id.split('_');
                let stageid = ids[0];
                let roleid = ids[1];

                statesMap.set(state.id, { defaultRule: true, roleId: roleid, stageId: stageid, value: state.value });
            }

            props.state = statesMap;
        }
    }

    // Capture raw unmarshaledXMLConnection to line model. Valid for workflow, behaviors, branches -- any path line.
    // Remember that Yoda unmarshaled XML attribute JS names have a "_" prefix.
    static loadPathLineProps(lineModel, unmarshaledXMLConnection) {
        // PF-2345 Preserves curved line inbound by overriding model defaults
        lineModel.attributes.lineType = unmarshaledXMLConnection._lineType;
        lineModel.attributes.ctrlPoint1x = unmarshaledXMLConnection._ctrlPoint1x;
        lineModel.attributes.ctrlPoint2x = unmarshaledXMLConnection._ctrlPoint2x;
        lineModel.attributes.ctrlPoint1y = unmarshaledXMLConnection._ctrlPoint1y;
        lineModel.attributes.ctrlPoint2y = unmarshaledXMLConnection._ctrlPoint2y;
    }

    // ConnectionVO (unfortunaately) assumes dupes of line model prpperties. Reflect those of the model to the VO base.
    static reflectModelToConnectionVO(connectionVO) {
        const lModel = connectionVO.model;
        connectionVO.lineType = lModel.attributes.lineType;
        connectionVO.ctrlPoint1x = lModel.attributes.ctrlPoint1x;
        connectionVO.ctrlPoint2x = lModel.attributes.ctrlPoint2x;
        connectionVO.ctrlPoint1y = lModel.attributes.ctrlPoint1y;
        connectionVO.ctrlPoint2y = lModel.attributes.ctrlPoint2y;
    }

}

const formLoadService = new FormLoadService();
export default formLoadService;
